<template>
  <div>
    <buttonlist @help="help" @opentable="opentable" @exps="downfile" ref="SetBtn"></buttonlist>
    <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
      <li class="left" ref="left" style="width: 15%">
        <div>
          <el-row>
            <el-button icon="el-icon-refresh-right" size="mini" @click="treeReflash('')" plain circle :title="$t('getapi[929]')" v-if="Permission.Node.refresh">
            </el-button>
            <el-button type="primary" icon="el-icon-folder-add" size="mini" @click="treeAdd" plain circle :title="$t('getapi[878]')" v-if="Permission.Node.create">
            </el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="treeEdit" plain circle :title="$t('getapi[34]')" v-if="Permission.Node.save">
            </el-button>
            <el-button type="primary" icon="el-icon-document-checked" size="mini" @click="treeSave" plain circle v-if="Permission.Node.save" :title="$t('getapi[937]')"></el-button>

            <el-button type="success" icon="el-icon-delete" size="mini" @click="treeDel" plain circle :title="$t('getapi[3889]')" v-if="Permission.Node.del">
            </el-button>
            <el-button type="success" icon="el-icon-setting" size="mini" @click="treeSet" plain circle :title="$t('getapi[7813]')" v-if="Permission.Node.upload"></el-button>

          </el-row>
        </div>
        <div :style="{height: treeheight1}">
          <el-scrollbar style="height: 100%;overflow-y: auto">
            <el-tree :highlight-current="true" lazy ref="tree" :data="dataTree" :props="defaultProps" node-key="node_id" :load="loadNode" :render-content="renderContent" :default-expanded-keys="defaultEexpandedkeys" @current-change="currentChange"
                     @node-click="nodeClick"></el-tree>
          </el-scrollbar>
        </div>
      </li>

      <li class="resize" ref="resize">
        <i class="el-icon-caret-right" @click="leftt(0)"></i>
        <i class="el-icon-caret-left" @click="leftt(1)"></i>
      </li>

      <li class="mid" ref="mid" style="width: 85%; margin-left: 3px">
        <div class="box">
          <div style="display:none">
            <input type="file" id="file1" @change="fileXlsChange()" accept=".xlsx" />
            <input type="file" id="file2" @change="filePdfChange()" multiple accept=".pdf" />
            <input type="file" id="file3" @change="fileSearchChange()" accept=".xlsx" />
            <input type="file" id="tbDXFfile" @change="onChangeFile4DXF()" multiple accept=".dxf" />
            <input type="file" id="tbDWGfile" @change="onChangeFile4DWG()" multiple accept=".dwg" />
            <input type="file" id="tb2QCfile" @change="onChangeFile2QC()" multiple title="替换QC文件" />
          </div>
          <el-tabs :tab-position="'top'" v-model="activeName" @tab-click="tabsHandleClick">
            <!-- 上传清单 -->
            <el-tab-pane :label="$t('getapi[6421]')" :name="search1.title" v-if="Permission.PDF.SC">
              <div style="white-space: nowrap;overflow: auto;">
              <div >
                <!-- style="width:1220px" -->
                <table style="border-spacing: 3px">
                  <tr>
                    <td class="myCell">
                      <el-button size="mini" type="success" @click="btnClick1('清单')" plain icon="el-icon-paperclip" title="1.选择清单模板">{{$t('getapi[6421]')}} </el-button>
                    </td>
                    <td class="myCell">
                      <el-button size="mini" type="success" @click="btnClick1('文件')" plain icon="el-icon-document-copy" title="2.选择PDF文件">{{$t('getapi[6507]')}}</el-button>
                    </td>
                    <td class="myCell">
                      <el-button size="mini" type="success" @click="btnClick1('上传')" plain icon="el-icon-upload" title="3.上传文件">{{$t('getapi[7814]')}}</el-button>
                    </td>
                    <td class="myCell">
                      <el-button size="mini" type="warning" @click="btnClick1('DXF')" plain icon="el-icon-document-checked" title="上传文件">{{$t('getapi[7815]')}}</el-button>
                    </td>
                    <td class="myCell">
                      <el-button size="mini" type="danger" @click="btnClick1('DWG')" plain icon="el-icon-document-checked" title="上传文件">{{$t('getapi[8192]')}}</el-button>
                    </td>
                    <td class="myCell">
                      <el-button type="primary" size="mini" icon="el-icon-search" plain @click="showGrid1(1)"> {{$t('getapi[7856]')}}</el-button>
                    </td>
                    <!-- <td class="myCellNew">
                      <el-link class="el-button--mini" type="primary" title="下载最新上传清单模板" href="/excel/上传零件模板ver1_2.xlsx" download="上传零件模板ver1_2.xlsx">{{$t('getapi[8123]')}}</el-link>
                    </td>
                    <td class="myCellNew">
                      <el-link class="el-button--mini" type="primary" title="下载最新上传工艺模板" href="/excel/工艺模板Ver1_1.xlsx" download="工艺模板Ver1_1.xlsx">{{$t('getapi[8124]')}}</el-link>
                    </td>
                    <td class="myCellNew">
                      <el-link class="el-button--mini" type="primary" title="下载最新上传外来文件模板" href="/excel/外来文件Ver1_0.xlsx" download="外来文件Ver1_0.xlsx">{{$t('getapi[8125]')}}</el-link>
                    </td>
                    <td class="myCell">
                      <el-link class="el-button--mini" type="primary" title="下载最新上传工艺装备模板" href="/excel/工艺装备Ver1_0.xlsx" download="工艺装备Ver1_0.xlsx">{{$t('getapi[8178]')}}</el-link>
                    </td> -->
                    <td class="myCell" style="vertical-align: middle;">
                      <span v-if="curNode"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span>
                      </span>
                    </td>
                    <td class="myCellNew"></td>
                  </tr>
                  <tr>
                    <td colspan="12">
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td class="myCell">
                      <el-checkbox v-model="search1.searchSub">{{$t('getapi[7818]')}}</el-checkbox>
                    </td>

                    <td class="myCell">
                      <el-select v-model="search1.enable_flag" filterable :placeholder="$t('getapi[7821]')" size="mini" :title="$t('getapi[7819]')">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCell">
                      <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="search1.doc_name"> </el-input>
                    </td>
                    <td colspan="5">
                      <div v-if="search1.info">
                        <el-progress :text-inside="true" :stroke-width="24" :percentage="search1.percentage" status="success"> </el-progress>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              </div>
              <!-- <hr style="border-color:lightcyan;"/> -->
              <!--  :cell-class-name="rowStyler6" -->
              <div>
                <!--<wTable
                        :data="search1.dataSet"
                        :loading="loading"
                        queryData="docmanageview"
                        :header="tableHeader"
                        :option="tableOption"
                        ref="singleTable"
                        :checkflg="false"
                        @fileClear6="fileClear6"
                        @fileDel6="fileDel6"
                ></wTable>-->
                <el-table style="width: 100%; margin-top: 1px;"
                          :height="search1.height"
                          :data="search1.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border size="mini"
                          header-row-class-name="headerclass">
                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')"  sortable key="etQD_root_name"></el-table-column>
                  <el-table-column width="120" prop="node_name" :label="$t('getapi[7828]')" sortable  key="etQD_node_name"></el-table-column>
                  <el-table-column width="240" prop="doc_name" :label="$t('getapi[7823]')" sortable  key="etQD_doc_name">
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="doc_version" :label="$t('getapi[113]')"  sortable key="etQD_doc_version"></el-table-column>
                  <el-table-column width="150" prop="part_list" :label="$t('getapi[112]')" sortable  key="etQD_part_list"></el-table-column>
                  <el-table-column width="150" prop="group_list" :label="$t('getapi[7824]')" sortable  key="etQD_group_list"></el-table-column>
                  <el-table-column width="90" prop="T1" :label="$t('getapi[6048]')" sortable  key="etQD_T1">
                    <template scope="scope">
                      <!--<span v-for="item1 in formatterT1(scope.row)" :key="item1.id" style="padding-left: 3px;font-size: 12px;">
                        <span :style="item1.style" @click="item1.click()">{{item1.text}}</span>
                      </span>-->
                      <span v-if="scope.row.docName2" style="color:blue;cursor:pointer;" @click="fileClear6(scope.row)">清除</span>
                      <span v-if="!scope.row.docName2 && scope.row.enable_flag == 3">{{row.enable_flag_text}}</span>
                      <span v-if="!scope.row.docName2 && (scope.row.enable_flag == -5 || scope.row.enable_flag == -6)" style="color:red;">{{row.enable_flag_text}}</span>
                      <span v-if="!scope.row.docName2 && (scope.row.enable_flag == -1 || scope.row.enable_flag == -2 || scope.row.enable_flag == 3 || scope.row.enable_flag == -5 || scope.row.enable_flag == -6)" style="color:blue;cursor:pointer;" @click="fileDel6(scope.row)">删除</span>
                      <span v-if="!scope.row.docName2 && (scope.row.enable_flag != -1 && scope.row.enable_flag != -2 && scope.row.enable_flag != 3 && scope.row.enable_flag != -5 && scope.row.enable_flag != -6)">{{row.enable_flag_text}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="item_type" :label="$t('getapi[118]')" sortable  key="etQD_item_type"></el-table-column>
                  <el-table-column width="70" prop="blueprint_no1" :label="$t('getapi[133]')"  sortable key="etQD_blueprint_no1"></el-table-column>
                  <el-table-column width="170" prop="hj_reason" :label="$t('getapi[8589]')" sortable  key="ethj_reason"></el-table-column>
                  <el-table-column width="170" prop="remark" :label="$t('getapi[143]')"  sortable key="etQD_remark"></el-table-column>
                  <el-table-column width="70" prop="enable_flag_text" :label="$t('getapi[552]')"  sortable key="etQD_enable_flag_text"></el-table-column>
                  <el-table-column width="80" prop="cus_draw_version" :label="$t('getapi[12858]')" sortable  key="etQD_cus_draw_version"></el-table-column>
                  <el-table-column width="80" prop="upload_person_name" :label="$t('getapi[6425]')" sortable  key="etQD_upload_person_name"></el-table-column>
                  <el-table-column width="130" prop="upload_time" :label="$t('getapi[6426]')"  sortable key="etQD_upload_time"></el-table-column>
                  <el-table-column width="130" prop="qc_node_text" :label="$t('getapi[7825]')" sortable  key="etQD_qc_node_text"></el-table-column>
                  <el-table-column width="130" prop="qc_person_time" :label="$t('getapi[7826]')" sortable  key="etQD_qc_person_time"></el-table-column>
                  <el-table-column width="70" prop="doc_count" :label="$t('getapi[7827]')"  sortable key="etQD_doc_count"></el-table-column>
                  
                </el-table>
              </div>
            </el-tab-pane>
            <!-- <div style="border-color: blue;border-width: 1px;border-style: inset;height: 680px;">              </div> -->
            <!-- 上传清单 -->

            <!-- 审核文件 -->
            <el-tab-pane :label="$t('getapi[7829]')" :name="search2.title" v-if="Permission.PDF.SH">
              <div style="white-space: nowrap;overflow: auto;">
              <div style="width:760px">
                <table style="border-spacing: 3px">
                  <tr>
                    <td class="myCellText">{{$t('getapi[7819]')}}</td>
                    <td style="width: 120px">
                      <el-select v-model="search2.enable_flag" filterable size="mini" @change="AuditChangeEnableFlag">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCellText">{{$t('getapi[7823]')}}</td>
                    <td style="width: 120px">
                      <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="search2.doc_name">
                      </el-input>
                    </td>
                    <td style="width: 120px;padding-left: 15px;">
                      <el-checkbox v-model="search2.searchSub">{{$t('getapi[7818]')}}</el-checkbox>
                    </td>
                    <td style="width: 120px">
                      <el-button type="primary" size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>

                    <td style="width: 150px">
                      <span v-if="curNode" :title="$t('getapi[7830]')">{{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span>
                    </td>
                  </tr>
                  <tr>
                    <!-- 批量审核 -->
                    <td class="myCellText">{{$t('getapi[1315]')}}</td>
                    <td colspan="3">
                      <!-- 通过 -->
                      <el-button type="success" size="mini" :disabled="!audit_pass" plain @click="BatchAudit('通过')" style="margin-left: 0px">
                        {{$t('getapi[12326]')}}
                      </el-button>
                      <!-- 拒绝 -->
                      <el-button type="warning" size="mini" :disabled="!audit_refuse" plain @click="BatchAudit('拒绝')" style="margin-left: 5px">
                        {{$t('getapi[12327]')}}
                      </el-button>
                      <!-- 反审 -->
                      <el-button type="primary" size="mini" :disabled="!audit_deapproval" plain @click="BatchAudit('反审')" style="margin-left: 5px">
                        {{$t('getapi[3718]')}}
                      </el-button>
                    </td>
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <!--<wTable
                        :data="search2.dataSet"
                        :loading="loading"
                        queryData="docmanageview2"
                        :header="tableHeader2"
                        :option="tableOption2"
                        ref="singleTable2"
                        :checkflg="false"
                        @fileAudit8_YesNoCancel="fileAudit8_YesNoCancel"
                ></wTable>-->
                <el-table
                        :data="search2.dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        show-overflow-tooltip="true"
                        border stripe size="mini"
                        :height="search2.height"
                        @selection-change="handleSelectionChangeAudit"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top: 3px">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')" sortable  key="etSH_root_name"></el-table-column>
                  <el-table-column width="120" prop="node_name" :label="$t('getapi[7828]')" sortable  key="etSH_node_name"></el-table-column>
                  <el-table-column width="240" prop="doc_name" :label="$t('getapi[7823]')" sortable  key="etSH_doc_name">
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="doc_version" :label="$t('getapi[113]')" sortable  key="etSH_doc_version"></el-table-column>
                  <el-table-column width="150" prop="part_list" :label="$t('getapi[112]')" sortable  key="etSH_part_list"></el-table-column>
                  <el-table-column width="150" prop="group_list" :label="$t('getapi[7824]')" sortable  key="etSH_group_list"></el-table-column>
                  <el-table-column width="90" prop="T1" :label="$t('getapi[6048]')" key="etSH_T1">
                    <template scope="scope">
                      <span v-for="item1 in formatterT2(scope.row)" :key="item1.id" style="padding-left: 3px;font-size: 12px;">
                        <span :style="item1.style" @click="item1.click()">{{item1.text}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="dcc_replace" :label="$t('getapi[12848]')" sortable  key="etSH_dcc_replace"></el-table-column>
                  <el-table-column width="70" prop="item_type" :label="$t('getapi[118]')" sortable  key="etSH_item_type"></el-table-column>
                  <el-table-column width="70" prop="blueprint_no1" :label="$t('getapi[133]')" sortable  key="etSH_blueprint_no1"></el-table-column>
                  <el-table-column width="80" prop="upload_person_name" :label="$t('getapi[6425]')" sortable  key="etSH_upload_person_name"></el-table-column>
                  <el-table-column width="130" prop="upload_time" :label="$t('getapi[6426]')" sortable key="etSH_upload_time"></el-table-column>
                  <el-table-column width="70" prop="remark" :label="$t('getapi[143]')" sortable  key="etSH_remark"></el-table-column>
                  <el-table-column width="80" prop="qc_person_name" :label="$t('getapi[7831]')" sortable  key="etSH_qc_person_name"></el-table-column>
                  <el-table-column width="130" prop="qc_person_time" :label="$t('getapi[7826]')" sortable  key="etSH_qc_person_time"></el-table-column>
                  <el-table-column width="80" prop="qc_flag" :label="$t('getapi[7832]')" sortable  key="etSH_qc_flag"></el-table-column>
                  <el-table-column width="70" prop="blueprint_no2" :label="$t('getapi[7833]')" sortable  key="etSH_blueprint_no2"></el-table-column>
                  <el-table-column width="70" prop="enable_flag_text" :label="$t('getapi[552]')" sortable  key="etSH_enable_flag_text"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <!-- 审核文件 -->

            <!-- 焊接图 -->
            <el-tab-pane :label="$t('getapi[7834]')" :name="searchHJ.title" v-if="Permission.PDF.HJT">
              <div style="white-space: nowrap;overflow: auto;">
              <div style="width:1000px">
                <table style="border-spacing: 3px">
                  <tr>
                    <td class="myCellText">{{$t('getapi[7819]')}}</td>
                    <td style="width: 120px">
                      <el-select v-model="searchHJ.enable_flag" filterable size="mini">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>

                    <td class="myCellText">{{$t('getapi[7823]')}}</td>
                    <td style="width: 120px">
                      <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="searchHJ.doc_name"></el-input>
                    </td>
                    <td class="myCellText">{{$t('getapi[546]')}}</td>
                    <td style="width: 120px">
                      <el-input size="mini" :placeholder="$t('getapi[7837]')" v-model="searchHJ.node_name"></el-input>
                    </td>
                    <td class="myCellText">
                      <el-checkbox v-model="searchHJ.searchSub">{{$t('getapi[7818]')}}</el-checkbox>
                    </td>
                    <td class="myCellText">{{$t('getapi[7836]')}}</td>
                    <td style="width: 100px">
                      <el-select v-model="searchHJ.qc_flag" filterable size="mini">
                        <el-option v-for="item in ComboboxQC" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td>
                    </td>
                  </tr>
                  <tr >
                    <td class="myCellText_btn_hjt" >
                      <el-button type="primary" size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>   
                    <td style="width: 100px">
                      <el-button type="primary" size="mini" icon="el-icon-copy-document" plain @click="btnClick1('焊接图')" style="margin-left: 8px">
                        {{$t('getapi[7835]')}}
                      </el-button>
                    </td>                 
                    <td style="width: 120px; text-align: right;">
                      <span v-if="curNode" :title="$t('getapi[7830]')"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span>
                      &nbsp;
                      <span :title="$t('getapi[7838]')" style="color: red;" id="searchHJ.info"></span>
                    </td>
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <el-table :data="searchHJ.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border stripe size="mini"
                          :height="searchHJ.height"
                          header-row-class-name="headerclass"
                          style="width: 100%; margin-top: 3px">

                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')" sortable  key="etHJ_root_name"></el-table-column>
                  <el-table-column width="120" prop="node_name" :label="$t('getapi[7828]')" sortable  key="etHJ_node_name"></el-table-column>
                  <el-table-column width="130" prop="qc_node_text" :label="$t('getapi[546]')" sortable  key="etHJ_qc_node_text"></el-table-column>
                  <el-table-column width="240" prop="doc_name" :label="$t('getapi[7823]')" sortable  key="etHJ_doc_name">
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="doc_version" :label="$t('getapi[113]')" sortable  key="etHJ_doc_version"></el-table-column>
                  <el-table-column width="150" prop="part_list" :label="$t('getapi[112]')" sortable  key="etHJ_part_list"></el-table-column>
                  <el-table-column width="70" prop="enable_flag_text" :label="$t('getapi[552]')" sortable  key="etHJ_enable_flag_text"></el-table-column>
                  <!-- <el-table-column width="90" prop="T1" :label="$t('getapi[6048]')" key="etHJ_T1"></el-table-column> -->
                  <el-table-column width="90" prop="T1" :label="$t('getapi[6048]')"  sortable key="etSH_T1">
                    <template scope="scope">
                      <span v-for="item1 in formatterT4(scope.row)" :key="item1.id" style="padding-left: 3px;font-size: 12px;">
                        <span :style="item1.style" @click="item1.click()">{{item1.text}}</span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="80" prop="qc_person_name" :label="$t('getapi[7831]')" sortable  key="etHJ_qc_person_name"></el-table-column>
                  <el-table-column width="130" prop="qc_person_time" :label="$t('getapi[7826]')" sortable  key="etHJ_qc_person_time"></el-table-column>
                  <el-table-column width="80" prop="vss_person_name" :label="$t('getapi[7839]')" sortable  key="etHJ_vss_person_name"></el-table-column>
                  <el-table-column width="130" prop="vss_person_time" :label="$t('getapi[7840]')" sortable  key="etHJ_vss_person_time"></el-table-column>
                  <el-table-column width="70" prop="item_type" :label="$t('getapi[118]')" sortable  key="etHJ_item_type"></el-table-column>
                  <el-table-column width="80" prop="qc_flag" :label="$t('getapi[7832]')"  sortable key="etHJ_qc_flag"></el-table-column>
                  <el-table-column width="80" prop="audit_person_name" :label="$t('getapi[550]')" sortable  key="etHJ_audit_person_name"></el-table-column>
                  <el-table-column width="130" prop="audit_time" :label="$t('getapi[732]')" sortable  key="etHJ_audit_time"></el-table-column>
                  
                </el-table>
              </div>
            </el-tab-pane>
            <!-- 焊接图 -->

            <!-- 发布文件  -->
            <el-tab-pane :label="$t('getapi[7842]')" :name="search3.title" v-if="Permission.PDF.FB">
              <div style="white-space: nowrap;overflow: auto;">
              <div style="width:1000px">
                <table style="border-spacing: 3px">
                  <tr>
                    <td class="myCellText">{{$t('getapi[7819]')}}</td>
                    <td style="width: 120px">
                      <el-select v-model="search3.enable_flag" filterable size="mini" :change="PulishChangeEnableFlag">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCellText">{{$t('getapi[7823]')}}</td>
                    <td style="width: 120px">
                      <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="search3.doc_name">
                      </el-input>
                    </td>
                    <td class="myCellText">{{$t('getapi[118]')}}</td>
                    <td style="width: 120px">
                      <el-input size="mini" :placeholder="$t('getapi[7843]')" v-model="search3.item_type">
                      </el-input>
                    </td>
                    <td class="myCellText">{{$t('getapi[12604]')}}</td>
                    <td style="width: 120px">
                      <el-date-picker
                        v-model="search3.create_time"
                        type="date"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        style="width:100%"
                      ></el-date-picker>
                    </td>
                    <td class="myCellText">{{$t('getapi[114]')}}</td>
                    <td style="width: 120px">                      
                      <el-select v-model="search3.part_status" :disabled="!Permission.PDF.WL" filterable size="mini">
                        <el-option v-for="item in CombPartStatus" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    
                  </tr>
                  <tr>
                    <td class="myCellText">
                      <el-button type="primary" size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>
                    <td style="width: 120px">
                      <el-button type="primary" size="mini" icon="el-icon-edit-outline" plain @click="dg1Click('显示')" :title="$t('getapi[7844]')" style="margin-left: 8px">
                        {{$t('getapi[7845]')}}
                      </el-button>
                    </td>
                    <!-- 批量发布 -->
                    <td class="myCellText">{{$t('getapi[12340]')}}</td>
                    <td colspan="2">
                      <!-- 通过 -->
                      <el-button type="success" size="mini" :disabled="!publish_pass" plain @click="BatchPublish('发布')" style="margin-left: 0px">
                        {{$t('getapi[12326]')}}
                      </el-button>
                      <!-- 拒绝 -->
                      <el-button type="warning" size="mini" :disabled="!publish_refuse" plain @click="BatchPublishCancel('拒绝')" style="margin-left: 8px">
                        {{$t('getapi[12327]')}}
                      </el-button>
                      <!-- 作废 -->
                      <el-button type="danger" size="mini" :disabled="!publish_void" plain @click="BatchPublishCancel('作废')" style="margin-left: 8px">
                        {{$t('getapi[1902]')}}
                      </el-button>
                    </td>
                    <td class="myCellText">
                      <el-checkbox v-model="search3.searchSub">{{$t('getapi[7818]')}}</el-checkbox>
                    </td>
                    <td class="myCellText">
                      <span v-if="curNode" :title="$t('getapi[7830]')"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span>
                    </td>
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <el-table :data="search3.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border stripe size="mini"
                          :height="search3.height"
                          header-row-class-name="headerclass"
                          @selection-change="handleSelectionChangePublish"
                          @row-click="search3RowClick"
                          style="width: 100%; margin-top: 3px">
                          <el-table-column type="selection"></el-table-column>
                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')" sortable  key="etFB_root_name"></el-table-column>
                  <el-table-column width="120" prop="node_name" :label="$t('getapi[7828]')"  sortable key="etFB_node_name"></el-table-column>
                  <el-table-column width="240" prop="doc_name" :label="$t('getapi[7823]')" sortable  key="etFB_doc_name">
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="doc_version" :label="$t('getapi[113]')" sortable  key="etFB_doc_version"></el-table-column>
                  <el-table-column width="150" prop="part_list" :label="$t('getapi[112]')" sortable  key="etFB_part_list"></el-table-column>
                  <el-table-column width="150" prop="group_list" :label="$t('getapi[7824]')"  sortable key="etFB_group_list"></el-table-column>
                  <el-table-column width="90" prop="T1" :label="$t('getapi[6048]')" sortable  key="etFB_T1">
                    <template scope="scope">
                      <span v-for="item1 in formatterT3(scope.row)" :key="item1.id" style="padding-left: 3px;font-size: 12px;">
                        <span :style="item1.style" @click="item1.click()">{{item1.text}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="70" prop="item_type" :label="$t('getapi[118]')" sortable  key="etFB_item_type"></el-table-column>
                  <el-table-column width="70" prop="blueprint_no1" :label="$t('getapi[133]')" sortable  key="etFB_blueprint_no1"></el-table-column>
                  <el-table-column width="70" prop="file_id" :label="$t('getapi[8087]')" sortable  key="etfile_id"></el-table-column>
                  <el-table-column width="70" prop="file_first_time" :label="$t('getapi[8240]')" sortable  key="etfile_first_time"></el-table-column>
                  <el-table-column width="70" prop="remark" :label="$t('getapi[143]')" sortable  key="etFB_remark"></el-table-column>
                  <el-table-column width="80" prop="upload_person_name" :label="$t('getapi[6425]')" sortable  key="etFB_upload_person_name"></el-table-column>
                  <el-table-column width="80" prop="audit_person_name" :label="$t('getapi[550]')" sortable  key="etFB_audit_person_name"></el-table-column>
                  <el-table-column width="80" prop="qc_person_name" :label="$t('getapi[7831]')" sortable  key="etFB_qc_person_name"></el-table-column>
                  <el-table-column width="130" prop="upload_time" :label="$t('getapi[6426]')" sortable  key="etFB_upload_time"></el-table-column>
                  <el-table-column width="130" prop="audit_time" :label="$t('getapi[732]')" sortable  key="etFB_audit_time"></el-table-column>
                  <el-table-column width="130" prop="qc_person_time" :label="$t('getapi[7826]')" sortable  key="etFB_qc_person_time"></el-table-column>
                  <el-table-column width="130" prop="doc_new_name" :label="$t('getapi[1176]')" sortable  key="etFB_doc_new_name"></el-table-column>
                  <el-table-column width="130" prop="part_statusname" :label="$t('getapi[114]')" sortable  key="etFB_part_statusname"></el-table-column>
                  <el-table-column width="130" prop="create_time" :label="$t('getapi[12604]')" sortable key="etFB_create_time"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <!-- 发布文件 -->

            <!-- 文件一览 -->
            <el-tab-pane :label="$t('getapi[7846]')" :name="search4.title" v-if="Permission.PDF.YL">
              <div style="white-space: nowrap;overflow: auto;">
              <div style="width:1000px">
                <table style="border-spacing: 3px">
                  <tr>                    
                      <td class="myCellText_View">{{$t('getapi[7823]')}}</td>
                      <td style="width: 150px">
                        <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="search4.doc_name">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[558]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[558]')" v-model="search4.doc_version">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[118]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7843]')" v-model="search4.item_type">
                      </el-input>  
                    </td>                    
                      <td class="myCellText_View">{{$t('getapi[133]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7849]')" v-model="search4.blueprint_no1">
                      </el-input>
                    </td>
                    <td class="myCellText_View">{{$t('getapi[7834]')}}</td>
                    <td style="width: 120px">
                        <el-select v-model="search4.qc_flag" filterable size="mini">
                        <el-option v-for="item in Combobox3" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>

                  <tr>
                    <td class="myCellText_View">{{$t('getapi[112]')}}</td>
                    <td style="width: 150px">
                      <el-input size="mini" :placeholder="$t('getapi[7847]')" v-model="search4.part_list">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7824]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7848]')" v-model="search4.group_list">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7819]')}}</td>
                      <td style="width: 120px">
                        <el-select v-model="search4.enable_flag" filterable size="mini" :disabled="!Permission.PDF.RS">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7828]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7850]')" v-model="search4.node_name">
                      </el-input>
                    </td>
                    <td class="myCellText_View">{{$t('getapi[11573]')}}</td>
                    <td style="width: 150px">
                      <el-input size="mini" :placeholder="$t('getapi[11573]')" v-model="search4.prosheetnum" @keydown.enter.native="saomadown" @keyup.enter.native="saomaup">
                      </el-input>
                    </td>
                    </tr>
                  <tr>
                    <td class="myCellText">{{$t('getapi[114]')}}</td>
                    <td style="width: 120px">                      
                      <el-select v-model="search4.part_status" :disabled="!Permission.PDF.WL" filterable size="mini">
                        <el-option v-for="item in CombPartStatus" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCellText_btn">
                      <el-button type="primary"  size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>
                    <td> <el-checkbox v-model="search4.searchSub">{{$t('getapi[7818]')}}</el-checkbox></td>
                    <td> <el-checkbox v-model="search4.shareflag">{{$t('getapi[12908]')}}</el-checkbox></td>
                    
                    <td class="myCellText"> <span v-if="curNode" :title="$t('getapi[7830]')"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span></td>
                    
                    <td class="myCellText_btn"> 
                      <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('P')" style="margin-left: 8px">
                        {{$t('getapi[6538]')}}
                      </el-button>
                    </td>
                      <td class="myCellText_btn"> <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('C')" style="margin-left: 8px">
                        {{$t('getapi[596]')}}
                      </el-button>
                    </td>
                      <td class="myCellText_btn"> <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('W')" style="margin-left: 8px">
                        {{$t('getapi[8502]')}}
                      </el-button>
                    </td>
                      
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <wTable
                        :data="search4.dataSet"
                        :loading="loading"
                        queryData="docmanageview4"
                        :header="tableHeader4"
                        :option="tableOption4"
                        ref="singleTable4"
                        :checkflg="false"
                        @cellclick="openPdfView"
                        @lct="lct"
                        @downxls="downxls"                        
                        @downdcc="downdcc" 
                ></wTable>
              </div>
            </el-tab-pane>
            <!-- 文件一览  -->

            <!-- 工艺取号  -->
             <el-tab-pane :label="$t('getapi[8122]')" :name="search6.title">
               <div style="white-space: nowrap;overflow: auto;">
                  <div style="width:1000px">
                <table style="border-spacing: 3px; ">
                  <tr>
                    <td class="myCellText_View">{{$t('getapi[8099]')}}</td>
                    <td  class="myCell">
                      <el-input style="width: 100px;" size="mini"  :placeholder="$t('getapi[8099]')" v-model="search6.scraft"></el-input>
                    </td>
                    <td class="myCellText_View">{{$t('getapi[8091]')}}</td>
                    <td style="width: 100px">
                      <el-select v-model="search6.sdept" filterable size="mini">
                        <el-option v-for="item in DeptCombox" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCellText_View">{{$t('getapi[8090]')}}</td>
                    <td class="myCell">
                      <el-input style="width: 100px;" size="mini" :placeholder="$t('getapi[8090]')" v-model="search6.sitem"></el-input>
                    </td>
                    <td class="myCellText_View">{{$t('getapi[8092]')}}</td>
                    <td style="width: 100px">
                      <el-select v-model="search6.spro" filterable size="mini">
                        <el-option v-for="item in ItemCombox" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>

                    <td style="width: 90px">
                      <el-button type="primary" size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>

                    <td style="width: 90px">
                      <el-button type="primary" size="mini"  icon="el-icon-edit-outline" @click="showOpenNumber" :title="$t('getapi[8119]')" style="margin-left: 8px">{{
                            $t('getapi[8119]') }}
                        </el-button>
                    </td>
                    <td class="myCellText_btn"> 
                      <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('N')" style="margin-left: 8px">
                      {{$t('getapi[12696]')}}
                      </el-button>
                    </td>
                  </tr>
                </table>
              </div>
               </div>
              <div style="">
                <!--<wTable
                        :data="search6.dataSet"
                        :loading="loading"
                        queryData="docmanageview6"
                        :header="tableHeader6"
                        :option="tableOption6"
                        ref="singleTable6"
                        @handleSelectionChange="handleSelectionChange"
                ></wTable>-->
                <el-table :data="search6.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border stripe size="mini"
                          :height="search6.height"
                          header-row-class-name="headerclass"
                          @selection-change="handleSelectionChangeYL" style="width: 100%; margin-top: 3px">
                  <el-table-column type="selection" width="55" prop="selectionValue" key="etPL_selectionValue"></el-table-column>
                  <el-table-column width="220" prop="id_group" :label="$t('getapi[8087]')" key="etid_group"></el-table-column>
                  <el-table-column width="80" align="center" prop="id_start" :label="$t('getapi[8088]')" key="etid_start">
                    <template scope="scope">
                      {{$limits.PrefixZero(scope.row.id_start,3)}}
                    </template>
                  </el-table-column>
                  <el-table-column width="80" align="center"  prop="id_end" :label="$t('getapi[8089]')" key="etid_end">
                    <template scope="scope">
                      {{$limits.PrefixZero(scope.row.id_end,3)}}
                    </template>
                  </el-table-column>
                  <el-table-column width="100" prop="id_item" :label="$t('getapi[8090]')" key="etiid_item"></el-table-column>
                  <el-table-column width="120" prop="id_dept" :label="$t('getapi[8120]')" key="etid_dept">
                    <template scope="scope">
                      {{formatterTdept(scope.row)}}
                    </template>
                  </el-table-column>
                  <el-table-column width="80" prop="id_type" :label="$t('getapi[8121]')" key="etid_type">
                    <template scope="scope">
                      {{formatterTItem(scope.row)}}
                    </template>
                  </el-table-column>
                  
                  <!-- <el-table-column width="100" prop="id_type" :label="$t('getapi[8121]')" key="etid_type"></el-table-column> -->
                  <!-- <el-table-column width="100" prop="id_no" :label="$t('getapi[8093]')" key="etid_no"></el-table-column> -->
                  <el-table-column width="70" prop="action_user" :label="$t('getapi[8094]')" key="etaction_user"></el-table-column>
                  <el-table-column width="120" prop="action_time" :label="$t('getapi[8095]')" key="etaction_time"></el-table-column>
                  <el-table-column width="70" align="center"  prop="id_text" :label="$t('getapi[8096]')" key="etid_text"></el-table-column>
                  <el-table-column width="70" align="center"  prop="id_wi" :label="$t('getapi[8097]')" key="etid_wi"></el-table-column>
                  <el-table-column width="80" prop="id_no" :label="$t('getapi[8098]')" key="etid_no"></el-table-column>
                  <el-table-column width="150" prop="remark" :label="$t('getapi[143]')" key="etremark"></el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <!-- 工艺取号 -->

            <!-- 批量检索 -->
            <el-tab-pane :label="$t('getapi[7853]')" :name="search5.title" v-if="Permission.PDF.PL">
              <div style="white-space: nowrap;overflow: auto;">
              <div style="width:1000px">
                <table style="border-spacing: 3px; ">
                  <tr>
                    <td rowspan="4" class="myCell" style="width: 250px;">
                      <el-input style="height: auto;font-size: 9px;" :rows="6" type="textarea" :placeholder="$t('getapi[7854]')" v-model="search5.doc_name"></el-input>
                    </td>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.searchGroup">{{$t('getapi[7824]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.cb10_nbt" style="color:blue;">{{$t('getapi[7855]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_batch">{{$t('getapi[7843]')}}</td>
                    <td class="myCell">
                      <el-input style="width: 120px;" size="mini"  v-model="search5.item_type"></el-input>
                    </td>
                    <td class="myCellText_batch">{{$t('getapi[114]')}}</td>
                    <td style="width: 130px">
                      <el-select v-model="search5.part_status"  :disabled="!Permission.PDF.WL" filterable size="mini">
                        <el-option v-for="item in CombPartStatus" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <!-- <td class="myCellText">{{$t('getapi[114]')}}</td> -->
                  </tr>
                  <tr>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.searchPart">{{$t('getapi[112]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.cb10_kht" style="color:blue;">{{$t('getapi[7857]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_batch">{{$t('getapi[7858]')}}</td>
                    <td class="myCell">
                      <el-date-picker style="width: 120px;" type="date" format="yyyy 年 MM 月 dd 日" size="mini"  v-model="search5.PublishDateTimeStart"> </el-date-picker>
                    </td>
                    <td class="myCellText_batch"></td>     
                    <td class="myCell_btn_right">
                      <el-button type="danger" size="mini" :disabled="!batchpublish_void" plain @click="VoidBatchPublishCancel('作废')" style="margin-left: 8px">
                        {{$t('getapi[1902]')}}
                      </el-button>
                      <el-button type="primary" size="mini" @click="showGrid1(1)" style="margin-left: 8px" plain icon="el-icon-search">{{$t('getapi[7856]')}} </el-button>
                    </td>
                    
                  </tr>
                  <tr>

                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.searchRoot" @change="searchRootChange">{{$t('getapi[7861]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.cb10_cgj" style="color:blue;">{{$t('getapi[446]')}}</el-checkbox>
                    </td>
                    <td class="myCellText_batch">{{$t('getapi[7862]')}}</td>
                    <td class="myCell">
                      <el-date-picker style="width: 120px;" type="date" format="yyyy 年 MM 月 dd 日" size="mini"  v-model="search5.PublishDateTimeEnd"> </el-date-picker>
                    </td>
                    <td class="myCellText_batch"></td>     
                    <td class="myCell_btn_right">
                      <el-button type="primary" size="mini" @click="downLoadZip()" style="margin-left: 8px" plain icon="el-icon-download">{{$t('getapi[7859]')}}</el-button>
                    </td>
                    
                  </tr>
                  <tr>
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.FuzzyQuery">{{$t('getapi[13119]')}}</el-checkbox>
                    </td>                      
                    <td class="myCellText_chex">
                      <el-checkbox v-model="search5.addblueprintNo">{{$t('getapi[7860]')}}</el-checkbox>
                    </td>    
                    <td class="myCellText_batch">{{$t('getapi[7849]')}}</td>              
                    <td class="myCell">
                      <el-input size="mini"  v-model="search5.blueprint_no1"> </el-input>
                    </td>
                    <td class="myCellText_batch"></td>     
                    <td class="myCell_btn_right">
                      <el-button type="primary" size="mini" @click="btnClick1('清单检索')" style="margin-left: 8px" :title="$t('getapi[7863]')" plain icon="el-icon-document">
                        {{$t('getapi[7864]')}}
                      </el-button>
                    </td>
                    <td class="myCell">
                      <div v-if="zip5.href">
                        <el-link id="myzip1"  @click="fnFmtPDFZip_New(zip5.href)" :title="zip5.title" :download="zip5.doc_name" style="padding:9px;margin-top:5px; font-size:9px;" type="success">
                          <span style="width: 200px;overflow:visible;display:inline-block;text-align: center;">
                            (&nbsp;<span style="color: blue;padding-left:3px;font-size:12px;">{{zip5.doc_name}}</span>&nbsp;)
                          </span>
                        </el-link>
                      </div>
                      <!-- 
                         style="padding:9px;margin-top:5px; font-size:9px;" type="success" :underline="false"
                         <a  style="padding:9px;margin-top: 5px; font-size: 9px ;width: 250px;"
                          :href="fnFmtPDFZip(zip5.href)" :title="zip5.title" download>
                          <span> 待下载压缩包(<span style="color: red;padding-left: 3px;">{{zip5.doc_name}}</span> )</span>
                          </a> 
                    <a :href="fnFmtPDFZip(zip5.href)" :title="zip5.title" :download="zip5.doc_name">{{zip5.doc_name}}</a> -->
                    </td>
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <wTable
                        :data="search5.dataSet"
                        :loading="loading"
                        queryData="docmanageview5"
                        :header="tableHeader5"
                        :option="tableOption5"
                        ref="singleTable5"
                        :cellClassName="classNameT5"
                        @handleSelectionChange="handleSelectionChangePL"
                ></wTable>
              </div>
            </el-tab-pane>
            <!-- 批量检索 -->
            
            <!-- DCC  -->
            <el-tab-pane :label="$t('getapi[12393]')" :name="searchDCC.title" v-if="Permission.PDF.DCC">
              <div style="white-space: nowrap;overflow: auto;">
                <div style="width:1000px">
                <table style="border-spacing: 3px">
                  <tr>                    
                      <td class="myCellText_View">{{$t('getapi[7823]')}}</td>
                      <td style="width: 150px">
                        <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="searchDCC.doc_name">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[558]')}}</td>
                      <td style="width: 130px">
                        <el-input size="mini" :placeholder="$t('getapi[558]')" v-model="searchDCC.doc_version">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[118]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7843]')" v-model="searchDCC.item_type">
                      </el-input>  
                    </td>    
                    <td><el-checkbox v-model="searchDCC.Dcc">{{$t('getapi[12410]')}}</el-checkbox></td> 
                    <td> <el-checkbox v-model="searchDCC.shareflag">{{$t('getapi[12908]')}}</el-checkbox></td>               
                      <!-- <td class="myCellText_View">{{$t('getapi[133]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7849]')" v-model="searchDCC.blueprint_no1">
                      </el-input>
                    </td> -->
                    <!-- <td class="myCellText_View">{{$t('getapi[7834]')}}</td>
                    <td style="width: 120px">
                        <el-select v-model="search4.qc_flag" filterable size="mini">
                        <el-option v-for="item in Combobox3" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td> -->
                    <td class="myCellText_btn"> 
                      <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('D')" style="margin-left: 8px">
                        {{$t('getapi[12561]')}}
                      </el-button>
                    </td>
                  </tr>
                  <tr >
                    <td class="myCellText_View">{{$t('getapi[112]')}}</td>
                    <td style="width: 150px">
                      <el-input size="mini" :placeholder="$t('getapi[7847]')" v-model="searchDCC.part_list">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7824]')}}</td>
                      <td style="width: 130px">
                        <el-input size="mini" :placeholder="$t('getapi[7848]')" v-model="searchDCC.group_list">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7819]')}}</td>
                      <td style="width: 120px">
                        <el-select v-model="searchDCC.enable_flag" filterable size="mini" :disabled="!Permission.PDF.RS">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                      <!-- <td class="myCellText_View">{{$t('getapi[7828]')}}</td>
                      <td style="width: 120px">
                        <el-input size="mini" :placeholder="$t('getapi[7850]')" v-model="searchDCC.node_name">
                      </el-input>
                    </td> -->
                    <!-- <td class="myCellText_View">{{$t('getapi[11573]')}}</td>
                    <td style="width: 150px">
                      <el-input size="mini" :placeholder="$t('getapi[11573]')" v-model="searchDCC.prosheetnum" @keydown.enter.native="saomadown" @keyup.enter.native="saomaup">
                      </el-input>
                    </td> -->
                    <td class="myCellText"> 
                      <span v-if="curNode" :title="$t('getapi[7830]')"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span>
                    </td>
                    <td style="width: 120px"> 
                        <el-button type="primary"  size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[7856]')}}
                      </el-button>
                    </td>
                    
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <el-table :data="searchDCC.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border stripe size="mini"
                          :height="searchDCC.height"
                          header-row-class-name="headerclass"
                          @selection-change="handleSelectionChangePublish"
                          @row-click="search3RowClick"
                          style="width: 100%; margin-top: 3px">
                  <!-- <el-table-column type="selection"></el-table-column> -->
                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')" key="etDcc_root_name" sortable></el-table-column>
                  <el-table-column width="90" prop="node_name" :label="$t('getapi[7828]')" key="etDcc_node_name" sortable></el-table-column>
                  <el-table-column width="130" prop="doc_name" :label="$t('getapi[7823]')" key="etDcc_doc_name" sortable>
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="50" prop="doc_version" :label="$t('getapi[113]')" key="etDcc_doc_version" sortable></el-table-column>
                  <el-table-column width="100" prop="part_list" :label="$t('getapi[112]')" key="etDcc_part_list" sortable></el-table-column>
                  <!-- <el-table-column width="120" prop="group_list" :label="$t('getapi[7824]')" key="etFB_group_list"></el-table-column> -->
                  <el-table-column width="70" prop="dcc_replace" :label="$t('getapi[12848]')" key="etDcc_dcc_replace" sortable></el-table-column>
                  <el-table-column width="70" prop="dcc_qe" :label="$t('getapi[12395]')" key="etDcc_dcc_qe" sortable></el-table-column>
                  <el-table-column width="100" prop="dcc_newcenter" :label="$t('getapi[12396]')" key="etDcc_dcc_newcenter" sortable></el-table-column>
                  <el-table-column width="90" prop="dcc_ic_insp" :label="$t('getapi[12397]')" key="etDcc_dcc_ic_insp" sortable></el-table-column>
                  <el-table-column width="100" prop="dcc_supplier" :label="$t('getapi[12398]')" key="etDcc_dcc_supplier" sortable></el-table-column>
                  <el-table-column width="130" prop="publish_time" :label="$t('getapi[7851]')" key="etDcc_publish_time" sortable></el-table-column>
                  <!-- <el-table-column width="120" prop="upload_time" :label="$t('getapi[6426]')" key="etYL_upload_time" sortable></el-table-column> -->
                  <el-table-column width="100" prop="upload_person_name" :label="$t('getapi[6425]')" key="etYL_upload_person_name" sortable></el-table-column>
                  <el-table-column width="100" prop="share_remark" :label="$t('getapi[12909]')" key="etYL_share_remark" sortable></el-table-column>
                  
                  
                </el-table>
              </div>
            </el-tab-pane>
            <!-- DCC -->

            <!-- QEM 管理体系文件  -->
            <!-- <el-tab-pane :label="$t('getapi[12563]')" :name="searchQEM.title" v-if="Permission.PDF.DCC">
              <div style="white-space: nowrap;overflow: auto;">
                <div style="width:1000px">
                <table style="border-spacing: 3px">
                  <tr>                    
                      <td class="myCellText_View">{{$t('getapi[7823]')}}</td>
                      <td style="width: 150px">
                        <el-input size="mini" :placeholder="$t('getapi[7820]')" v-model="searchQEM.doc_name">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[113]')}}</td>
                      <td style="width: 130px">
                        <el-input size="mini" :placeholder="$t('getapi[113]')" v-model="searchQEM.doc_version">
                      </el-input>
                    </td>
                    <td> <el-checkbox v-model="searchQEM.searchSub">{{$t('getapi[7818]')}}</el-checkbox></td>
                    <td class="myCellText_btn"> 
                      <el-button type="primary" size="mini" icon="el-icon-download" plain @click="exportdate('Q')" style="margin-left: 8px">
                        {{$t('getapi[12566]')}}
                      </el-button>
                    </td>
                  </tr>
                  <tr>
                    <td class="myCellText_View">{{$t('getapi[871]')}}</td>
                    <td style="width: 150px">
                      <el-input size="mini" :placeholder="$t('getapi[871]')" v-model="searchQEM.part_list">
                      </el-input>
                    </td>
                      <td class="myCellText_View">{{$t('getapi[7819]')}}</td>
                      <td style="width: 120px">
                        <el-select v-model="searchQEM.enable_flag" filterable size="mini" :disabled="!Permission.PDF.RS">
                        <el-option v-for="item in Combobox1" :key="item.Code" :label="item.Name" :value="item.Code">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="myCellText"> 
                      <span v-if="curNode" :title="$t('getapi[7830]')"> {{$t('getapi[7817]')}}:<span style="color: blue ;">{{curNode.node_name}}</span></span>
                    </td>
                    <td style="width: 120px"> 
                        <el-button type="primary"  size="mini" icon="el-icon-search" plain @click="showGrid1(1)" style="margin-left: 8px">
                        {{$t('getapi[3617]')}}
                      </el-button>
                    </td>
                    
                  </tr>
                </table>
              </div>
              </div>
              <div style="">
                <el-table   
                        :data="searchQEM.dataSet"
                          ref="singleTable"
                          v-loading="loading"
                          show-overflow-tooltip="true"
                          border stripe size="mini"
                          :height="searchDCC.height"
                          header-row-class-name="headerclass"
                          @selection-change="handleSelectionChangePublish"
                          @row-click="search3RowClick"
                          style="width: 100%; margin-top: 3px">
                  <el-table-column width="80" prop="root_name" :label="$t('getapi[7822]')" key="etQem_root_name" sortable></el-table-column>
                  <el-table-column width="90" prop="node_name" :label="$t('getapi[7828]')" key="etQem_node_name" sortable></el-table-column>
                  <el-table-column width="100" prop="group_list" :label="$t('getapi[12565]')" key="etQem_group_list" sortable></el-table-column>
                  <el-table-column width="250" prop="doc_name" :label="$t('getapi[7823]')" key="etQem_doc_name" sortable>
                    <template slot-scope="scope">
                      <span v-if="scope.row.hash_value">
                        <el-link type="primary" :underline="false" :href="fnFmtPDFZip(scope.row.hash_value)" target="_blank">
                          <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                        </el-link>
                      </span>
                      <span v-else>
                        <span :style="fmtDocNameColor(scope.row)"> {{scope.row.doc_name}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="80" prop="doc_version" :label="$t('getapi[4625]')" key="etQem_doc_version" sortable></el-table-column>
                  <el-table-column width="130" prop="part_list" :label="$t('getapi[871]')" key="etQem_part_list" sortable></el-table-column>
                  <el-table-column width="100" prop="item_type" :label="$t('getapi[4053]')" key="etQem_item_type" sortable></el-table-column>
                  
                  <el-table-column width="130" prop="publish_time" :label="$t('getapi[7851]')" key="etQem_publish_time" sortable></el-table-column>
                  <el-table-column width="100" prop="upload_person_name" :label="$t('getapi[6425]')" key="etQem_upload_person_name" sortable></el-table-column>
                  
                </el-table>
              </div>
            </el-tab-pane>  -->
            <!-- QEM -->
          </el-tabs>
        </div>

        <div class="box myLi" style="height: 30px;">
          <!-- 分页  -->
          <el-row class="page">
            <el-col :span="20">
              <el-pagination style="margin-left: 15px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="myPage.PageIndex" :page-sizes="[50,100, 200, 500, 1000]" :page-size="myPage.PageSize"
                             :page-count="myPage.PageCount" :total="myPage.Totals" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </el-col>
            <el-col :span="4">
              <div style="text-align: left;line-height: 30px;color: #545c64;font-size: 95%;">
                {{$t('getapi[7980]')}}:{{myPage.DbTbNames}}
              </div>
            </el-col>
          </el-row>
        </div>
      </li>
    </ul>

    <div>
      <el-dialog v-dialogDrag :title="$t('getapi[7865]')" :visible.sync="dg1.visible" width="420px" :close-on-click-modal="false" center>
        <table style="border-spacing: 3px; ">
          <tr>
            <td class="myCellText">
              {{$t('getapi[7823]')}}
            </td>
            <td class="myCell">
              <el-input size="small" :placeholder="$t('getapi[7843]')" v-model="dg1.doc_name" readonly></el-input>
            </td>
          </tr>
          <tr>
            <td class="myCellText">
              {{$t('getapi[112]')}}
            </td>
            <td class="myCell" style="width: 250px;">
              <el-input style="height: auto;font-size: 9px;" :rows="6" type="textarea" v-model="dg1.part_list" :placeholder="$t('getapi[7866]')">
              </el-input>
            </td>
          </tr>
          <tr>
            <td class="myCellText">
              {{$t('getapi[7824]')}}
            </td>
            <td class="myCell" style="width: 250px;">
              <el-input style="height: auto;font-size: 9px;" :rows="6" type="textarea" v-model="dg1.group_list" :placeholder="$t('getapi[7866]')">
              </el-input>
            </td>
          </tr>
        </table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dg1.visible = false">{{$t('getapi[6]')}}</el-button>
          <el-button type="primary" @click="dg1Click('修改')">{{$t('getapi[1146]')}}</el-button>
        </div>
      </el-dialog>


      <!-- 工艺取号编辑 -->
    <el-dialog v-dialogDrag :visible.sync="isVisibleNumber" :title="$t('getapi[8119]')" width="40%" :close-on-click-modal="false">
          <el-row>
              <el-col :span="24">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="80px"  label-position="left" size="small">
                      <el-row>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8099]')">
                                  <el-input v-model="formInline.id_text" readonly value="WT-XJ" :placeholder="$t('getapi[8099]')"></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8091]')">
                                <el-select v-model="formInline.id_dept" filterable size="mini">
                                  <el-option v-for="item in DeptCombox" :key="item.Code" :label="item.Name" :value="item.Code">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                          </el-col>
                      </el-row> 
                      <el-row>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8097]')">
                                  <el-input  v-model="formInline.id_wi" readonly value="WI" :placeholder="$t('getapi[8097]')"></el-input>
                              </el-form-item>
                          </el-col>                        
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8090]')">
                                  <el-input v-model="formInline.id_item" :placeholder="$t('getapi[8090]')"></el-input>
                              </el-form-item>
                          </el-col>
                        </el-row> 
                        <el-row>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8092]')">
                                  <el-select v-model="formInline.id_type" filterable size="mini">
                                    <el-option v-for="item in ItemCombox" :key="item.Code" :label="item.Name" :value="item.Code">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[8093]')">
                                  <el-input v-model="formInline.id_no" :placeholder="$t('getapi[8093]')"></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row> 
                      <el-row>
                          <el-col :span="12">
                              <el-form-item :label="$t('getapi[143]')">
                                  <el-input v-model="formInline.remark"  :placeholder="$t('getapi[143]')"></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>                      
                  </el-form>
              </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isVisibleNumber = false">{{ $t('getapi[6]') }}</el-button>
            <el-button type="primary" @click="OpenNumberSava"  :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
          </span>
     </el-dialog>
     <el-dialog v-dialogDrag :visible.sync="isVisibleFile" :title="$t('getapi[8167]')" style="margin-top:-60px;" width="70%"  :close-on-click-modal="false">
      <!-- // [pdfUrl] 获取pdf地址 eg：http://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf -->
          <iframe ref="mainiframe" :src="pdfurl" style="height:600px;width:100%" ></iframe>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="hjVisiable" width="30%" :close-on-click-modal="false">
            <div>
                <el-input v-model="hj_reason" type="textarea" size="mini"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="hjVisiable = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmHJ(0)">{{$t('getapi[6188]')}}</el-button>
				<el-button type="success" @click="confirmHJ(1)">{{$t('getapi[6187]')}}</el-button>
			</span>
        </el-dialog>
    </div>

    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview" tabNo="0"  ref="ctab"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview2" tabNo="0" ref="ctab2"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview3" tabNo="0" ref="ctab3"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview4" tabNo="0" ref="ctab4"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview5" tabNo="0" ref="ctab5"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview6" tabNo="0" ref="ctab6"
            @getctab="sortclick"></ctable>
    <ctable :isVisible="false" :title="$t('getapi[6575]')" queryData="docmanageview7" tabNo="0" ref="ctab7"
            @getctab="sortclick"></ctable>
  </div>

</template>
<script>
  import Common from "@/components/Common";
  import Array from "@/components/Array";
  import CommonHeader from "@/components/CommonHeader";
  let arrFlag = [
    { Code: "-2", Name: "清单待上传" },
    { Code: "-1", Name: "清单已上传" },
    { Code: "0", Name: "待审核" },
    { Code: "1", Name: "已审核" },
    { Code: "2", Name: "已发布" },
    { Code: "3", Name: "已作废" },
    { Code: "-10", Name: "审批中" },
    { Code: "-5", Name: "审核退回" },
    { Code: "-6", Name: "发布退回" },
    { Code: "-4", Name: "退回" },
    { Code: "", Name: "全部" }];

  let arrFlagQC = [
    { Code: "0", Name: "待替换" },
    { Code: "1", Name: "已替换" },
    { Code: "-1", Name: "QE控制" },
    { Code: "", Name: "全部" }
  ];
  let arrWelding = [
    { Code: "", Name: "否" },
    { Code: "1", Name: "是" },
  ];
  let arrPartStatus = [
    { Code: "1", Name: "可用" },
    { Code: "0", Name: "不可用" },
    { Code: "2", Name: "无物料" },
    { Code: "", Name: "全部" }
  ];
  
  // let deptDrop = [
  //   { Code: "ED", Name: "工程部-ED" },
  //   { Code: "SD", Name: "供应商开发-SD" },
  //   { Code: "PD", Name: "生产部-PD" },
  //   { Code: "BD", Name: "事业部-BD" },
  //   { Code: "MD", Name: "物料部-MD" },
  //   { Code: "HR", Name: "行政人事部-HR" },
  //   { Code: "OD", Name: "运营改善部-OD" },
  //   { Code: "QD", Name: "质量部-QD" }
  // ];

  // let itemDrop = [
  //   { Code: "BZ", Name: "包装-BZ" },
  //   { Code: "BM", Name: "表面处理-BM" },
  //   { Code: "CP", Name: "成品-CP" },
  //   { Code: "HJ", Name: "焊接-HJ" },
  //   { Code: "JG", Name: "激光-JG" },
  //   { Code: "PT", Name: "喷涂-PT" },
  //   { Code: "SC", Name: "数冲-SC" },
  //   { Code: "SY", Name: "丝印-SY" },
  //   { Code: "YLJ", Name: "压力机-YLJ" },
  //   { Code: "YM", Name: "压铆-YM" },
  //   { Code: "ZW", Name: "折弯-ZW" },
  //   { Code: "ZP", Name: "装配-ZP" }
  // ];

  export default {
    name: "docmanageview",
    data() {
      let curheight = window.innerHeight - 65 - 45; // 主表高度,

      return {
        isVisibleNumber:false,
        isVisibleFile:false,
        hjVisiable:false,
        hj_reason:'',
        hj_doc_id:0,
        selectDataAudit:[],
        selectDataPublish:[],
        audit_pass:false,//审核 通过
        audit_refuse:false,//审核 拒绝
        audit_deapproval:false,//审核 反审
        publish_pass:false,//发布 通过
        publish_refuse:false,////发布 拒绝
        publish_void:false,////发布 作废
        batchpublish_void:false,////发布 作废
        hj_doc_name:'',
        pdfurl:'',
        fileList: [],
        dataTree: [], //根节点的树
        Combobox1: arrFlag, // 上传清单
        CombPartStatus: arrPartStatus, // 物料状态       
        ComboboxQC: arrFlagQC,
        Combobox3: arrWelding, // 焊接图

        tableHeight: curheight, // 主表高度,
        curNode: null,
        DeptCombox:[], //
        ItemCombox:[], //
        //node_name: null, part_list: null, group_list: null,item_type: null, blueprint_no1: null
        search1: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview'), DbTbNames: null },
          dataSet: [], title: "清单上传", height: curheight - 120 - 30,
          enable_flag: "-2", node_id: null, doc_name: null, searchSub: false,
          info: null, percentage: 1
        },
        search2: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview2'), DbTbNames: null },
          dataSet: [], title: "审核文件", height: curheight - 120,
          enable_flag: "0", node_id: null, doc_name: null, searchSub: false,
        },
        search3: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview3'), DbTbNames: null },
          dataSet: [], title: "发布文件", height: curheight - 120,
          enable_flag: "1", node_id: null, doc_name: null, item_type: null, searchSub: false,create_time:null,part_status:'1'
        },
        search4: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview4'), DbTbNames: null },
          dataSet: [], title: "文件一览", height: curheight - 120 - 30,
          enable_flag: "2", node_id: null, doc_name: null, item_type: null,qc_flag:null,
          part_list: null, group_list: null,doc_version:null, searchSub: true, blueprint_no1: null,create_time:null,part_status:'1',shareflag:false,prosheetnum:'',
        },
        search5: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview5'), DbTbNames: null },
          dataSet: [], title: "批量检索", height: curheight - 120 - 95,
          enable_flag: "2", node_id: null, doc_name: null, node_name: null, part_list: null, group_list: null,
          item_type: null, blueprint_no1: null,
          searchSub: true, searchGroup: false, searchPart: false, searchRoot: null, addblueprintNo: true,FuzzyQuery:true,part_status:'1',
          PublishDateTimeStart: null, PublishDateTimeEnd: null,
          multipleSelection: [],
          cb10_nbt: true, cb10_kht: true, cb10_cgj: true,
        },
        search6: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview6'), DbTbNames: null },
          dataSet: [], title: "工艺取号", height: curheight - 95,
          enable_flag: "2", node_id: null, doc_name: null, node_name: null,multipleSelectionYL: [],
          scraft: "WT-XJ", sitem: null,sdept: null,spro: null,
        },
        searchHJ: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview7'), DbTbNames: null },
          dataSet: [], title: "焊接图", height: curheight - 120,
          enable_flag: "-10", node_id: null, doc_name: null, node_name: null, qc_flag: "0", searchSub: false,
          nbtText: null,
          info: null
        },
        searchDCC: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview8'), DbTbNames: null },
          dataSet: [], title: "DCC", height: curheight - 120,
          enable_flag: "2", node_id: null, doc_name: null, item_type: null,qc_flag:null,
          part_list: null, group_list: null,doc_version:null, searchSub: true, blueprint_no1: null,Dcc:true,shareflag:false,
        },
        searchQEM: {
          Page: { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: this.$http.getPageSize('docmanageview9'), DbTbNames: null },
          dataSet: [], title: "QEM", height: curheight - 120,
          enable_flag: "2", node_id: null, doc_name: null, item_type: null,qc_flag:null,
          part_list: null, group_list: null,doc_version:null, searchSub: true, blueprint_no1: null,QEM:true,
        },

        tableHeader: [],
        tableHeader2: [],
        tableHeader3: [],
        tableHeader4: [],
        tableHeader5: [],
        tableHeader6: [],
        tableHeader7: [],
        tableOption: {
            border: true,
            height: curheight - 120 - 30, // 主表高度ss
            maxHeight: curheight - 120 - 30 // 主表高度
        },
        tableOption2: {
            border: true,
            height: curheight - 120, // 主表高度ss
            maxHeight: curheight - 120 // 主表高度
        },
        tableOption3: {
            border: true,
            height: curheight - 120, // 主表高度ss
            maxHeight: curheight - 120 // 主表高度
        },
        tableOption4: {
            border: true,
            height: curheight - 120 - 45, // 主表高度ss
            maxHeight: curheight - 120 - 45 // 主表高度
        },
        tableOption5: {
            border: true,
            height: curheight - 120 - 95, // 主表高度ss
            maxHeight: curheight - 120 - 95 // 主表高度
        },
        tableOption6: {
            border: true,
            height: curheight - 95, // 主表高度ss
            maxHeight: curheight - 95 // 主表高度
        },
        tableOption7: {
            border: true,
            height: curheight - 120, // 主表高度ss
            maxHeight: curheight - 120// 主表高度
        },
        SelectIndex: 0,
        zip5: {
          // href: "ZIP/1_86eecc676f4344dda57489eb57b3dfbb.zip",
          href: null,
          doc_name: "xxxx.zip",
          title: "压缩文件"
        },

        activeName: '清单上传',
        fileXls: { data: null },//清单文件 value 绑定无效
        filePdf: { data: null },//Pdf文件
        treeheight1: window.innerHeight - 200 + 'px',
        userData: null, // 操作人信息

        id_tree: 0,
        defaultProps: {
          children: "children",
          label: "node_name",
          node_id: "node_id",
          isShowG: "isShowG",
        },
        defaultEexpandedkeys: [],
        loading: false, // 主表加载状态
        isact: "", //当前待编辑的节点
        isactTitle: "", //记录修改节点名称
        isUpdateGroup: false, //是否在修改模板组
        treeOType: -1, //1:新增2：编辑
        resolve_had: [],
        dg1: {
          /*编辑对话框*/
          visible: false,
          doc_name: "",
          part_list: "",
          group_list: "",
          doc_id: null,
          curRow: null
        },
        Permission: {
          P_LV2: 394,       //图纸一览
          P_LV4_384: 384,  //右键上传
          P_LV4_385: 385,  //右键审核
          P_LV4_386: 386,  //右键发布
          P_LV4_387: 387,  //右键批量

          Node: { create: false, save: false, del: false, refresh: true, upload: false },
          PDF: { SC: false, SH: false, FB: false, YL: true, PL: false,RS:false,DCC:false,WL:false }
        },
        nodeidflag: -1,
        formInline:{
          id_sort:0,
          id_text:"",
          id_dept:"",
          id_wi:"",
          id_item:"",
          id_type:"",
          id_start:0,
          id_no:0,
          id_end:0,
          id_group:"",
          action_time:"",
          action_user:"",
          deptDrop:[],
          itemDrop:[],
          remark:'',
        },
        WIType:"",
        WIPre:"",
        keydowntime:'',
        keyuptime:'',
        loadfileurl:'',
        nodetype:0,
      }
    },
    beforeRouteEnter(to, form, next){
          next(vm => {
              if(form.name=='BOM' && Object.keys(vm.$store.state.sharedParams).length > 0){
                  vm.activeName = vm.search4.title;
                  const quer = {...vm.$store.state.sharedParams};
                  vm.search4.part_list=quer.part_code;
                  vm.search4.prosheetnum='';
                  if (!vm.$limits.fnIsEmpty(vm.search4.part_list)) {
                      vm.showGrid1(1);
                  }
                  vm.$store.commit('clearSharedParams')
              }
              if(form.name=='2_soview' && Object.keys(vm.$store.state.sharedParams).length > 0){
                  vm.activeName = vm.search4.title;
                  const quer = {...vm.$store.state.sharedParams};
                  vm.search4.prosheetnum=quer.schedule_no;
                  vm.search4.part_list='';
                  if (!vm.$limits.fnIsEmpty(vm.search4.prosheetnum)) {
                      vm.showGrid1(1);
                  }
                  vm.$store.commit('clearSharedParams')
              }
              if(form.name=='ppoverview' && Object.keys(vm.$store.state.sharedParams).length > 0){
                  vm.activeName = vm.search4.title;
                  const quer = {...vm.$store.state.sharedParams};
                  vm.search4.part_list=quer.part_code;
                  if (!vm.$limits.fnIsEmpty(vm.search4.part_list)) {
                      vm.showGrid1(1);
                  }
                  vm.$store.commit('clearSharedParams')
              }
              if(form.name=='wxprice' && Object.keys(vm.$store.state.sharedParams).length > 0){
                  vm.activeName = vm.search4.title;
                  const quer = {...vm.$store.state.sharedParams};
                  vm.search4.part_list=quer.part_code;
                  if (!vm.$limits.fnIsEmpty(vm.search4.part_list)) {
                      vm.showGrid1(1);
                  }
                  vm.$store.commit('clearSharedParams')
              }
            /*if (quer.schedule_no) {
                vm.activeName = vm.search4.title;
                let quer = vm.$store.state.sharedParams;
              vm.search4.prosheetnum=quer.schedule_no;

              if (!vm.$limits.fnIsEmpty(vm.search4.prosheetnum)) {
                  vm.showGrid1(1);
              }
            }*/
          });
    },
    mounted: function () {
      let that = this;
      that.loadfileurl=window.location.host;
      that.deptDrop=Array.methods.getDepartCode();
      that.itemDrop=Array.methods.getRoutingTypeCode();
      //工艺取号类型
      that.WIType=Array.methods.getSysConfig('C07');
      
      //工艺取号前缀
      that.WIPre=Array.methods.getSysConfig('C06');
      that.search6.scraft=that.WIPre;
      that.DeptCombox=that.deptDrop; 
      that.ItemCombox=that.itemDrop;
      that.$refs.SetBtn.SetButtonEnable('')
      that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
      that.colsort();
      // let myDate = new Date();
      // myDate.setDate(myDate.getDate() - 60);
      // that.search5.PublishDateTimeStart = myDate;

      let s1 = that.fnToNull(sessionStorage.getItem('userData'));
      if (!s1) {
        that.userData = null;
        console.warn('sessionStorage:userdata is null');
      }
      else {
        that.userData = JSON.parse(s1);
      }
      let pNode = that.Permission.Node;
      let pPDF = that.Permission.PDF;
      let plv2 = that.$limits.authority('plv2', that.Permission.P_LV2, 1);
      if (plv2 == 0) {
        pNode.refresh = true;
      } else if (plv2 == 1) {
        // 查询
        pPDF.YL = true;

      } else if (plv2 == 2) {
        //操作权
        let plv3 = that.$limits.authority('plv3', that.Permission.P_LV2, 1);
        if (plv3 == 1) {
          // 编辑级
          pNode.create = true;
          pNode.save = true;
        } else if (plv3 == 2) {
          // 删除级
          pNode.create = true;
          pNode.save = true;
          pNode.del = true;
          pNode.upload = true;
        }
        else {
          pNode.refresh = true;
        }
      }
      else {
        pNode.refresh = true;
      }
      let plv4_384 = that.$limits.authority('plv4', that.Permission.P_LV4_384, 1);
      if (plv4_384 == 1) {
        pPDF.SC = true; //右键上传
      }
      let plv4_385 = that.$limits.authority('plv4', that.Permission.P_LV4_385, 1);
      if (plv4_385 == 1) {
        pPDF.SH = true; //右键审核
      }
      let plv4_386 = that.$limits.authority('plv4', that.Permission.P_LV4_386, 1);
      if (plv4_386 == 1) {
        pPDF.FB = true; //右键发布
        that.batchpublish_void=true;//批量检索(作废按钮)
      }
      else{
        that.batchpublish_void=false;//批量检索(作废按钮)
      }
      let plv4_387 = that.$limits.authority('plv4', that.Permission.P_LV4_387, 1);
      if (plv4_387 == 1) {
        pPDF.PL = true; //右键批量
      }
      if(that.$limits.authority('plv4', 570, 1)>0){
        pPDF.RS = true; //文件一览—文件状态
      }

      if(that.$limits.authority('plv4', 580, 1)>0){
        pPDF.WL = true; //物料状态
      }

      if(that.$limits.authority('plv4', 574, 1)>0){
        pPDF.DCC = true; //DCC 页签
      }
      if(that.$limits.authority('plv4', 597, 1)>0){
        pPDF.HJT = true; //焊接图
      }
      
      if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
          that.$refs.SetBtn.SetOneBtnEnable('help',true);
      }
      that.$refs.SetBtn.SetButtonEnable('export',true);
      //console.log('------------', pNode, pPDF);
      that.getRootNode();

      that.$limits.dragControllerDiv();

    }, computed: {
      myPage: function () {
        let curSearch = this.getSearch();
        if (curSearch) {
          return curSearch.Page;
        }
        else {
          return { Totals: 0, PageCount: 0, PageIndex: 1, PageSize: 500, DbTbNames: "defualt" };
        }
      }
    },
    methods: {
      help(){
        this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6575]"),this.$t("getapi[79]"));
      },
      downfile() {
          let that = this;          
          let hrefurl = Common.Url + "/help/技术文档操作说明.doc";
          window.open(hrefurl);
      },
      colsort() {
          let that = this;
          that.$loadviewfields.Fileds('docmanageview', 0, PFileds => {
              that.tableHeader=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview2', 0, PFileds => {
              that.tableHeader2=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview3', 0, PFileds => {
              that.tableHeader3=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview4', 0, PFileds => {
              that.tableHeader4=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview5', 0, PFileds => {
              that.tableHeader5=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview6', 0, PFileds => {
              that.tableHeader6=PFileds;
          });
          that.$loadviewfields.Fileds('docmanageview7', 0, PFileds => {
              that.tableHeader7=PFileds;
          });
      },
      sortclick(val) {
          if (val == 1) {
              this.colsort();
          }
      },
      // 修改表格顺序
      opentable() {
          let that = this
          if(that.activeName == that.search1.title){
              this.$refs.ctab.clearInputs(true);
          } else if (that.activeName == that.search2.title) {
              this.$refs.ctab2.clearInputs(true);
          } else if (that.activeName == that.search3.title) {
              this.$refs.ctab3.clearInputs(true);
          } else if (that.activeName == that.search4.title) {
              this.$refs.ctab4.clearInputs(true);
          } else if (that.activeName == that.search5.title) {
              this.$refs.ctab5.clearInputs(true);
          } else if (that.activeName == that.search6.title) {
              this.$refs.ctab6.clearInputs(true);
          } else if (that.activeName == that.searchHJ.title) {
              this.$refs.ctab7.clearInputs(true);
          }
          else if (that.activeName == that.searchDCC.title) {
              this.$refs.ctab8.clearInputs(true);
          }
          else if (that.activeName == that.searchQEM.title) {
              this.$refs.ctab9.clearInputs(true);
          }
      },
      openPdfView(row,column,cell,event) {
        let that=this;
        if(column.property=='doc_name'){
          if (that.$limits.fnIsEmpty(row.hash_value)) {
            return;
          }
          if(that.userData.Login_DB.toLowerCase()=="my"){
            let  hash_url= that.fnFmtPDFZip(row.hash_value);
            window.open(hash_url,"_blank");
          }
          else
          {
            if(row.hash_value.toLowerCase().includes('.pdf')){            
              let href = row.hash_value.replace(/\\/g, "/");
              var fileurl=window.location.host;
              if(fileurl=="47.100.58.231:8091" || fileurl=="192.168.0.2:8091"){
                // that.pdfurl = './pdf/generic/web/viewer.html?file='+Common.FileUrl+'/file/' + href;
                that.pdfurl = Common.FileUrl+'/file/' + href;
              }
              else{
                // that.pdfurl = './pdf/generic/web/viewer.html?file=/file/' + href;
                that.pdfurl =Common.InUrl+'/file/'+href;
              }
              window.open(that.pdfurl,"_blank");
            }
            else if(row.hash_value.toLowerCase().includes('.xls') || row.hash_value.toLowerCase().includes('.xlsx')){
                //execl 文件通过转换成PDF查看 并增加下载EXECL功能
                if (!that.$limits.fnIsEmpty(row.xlstopsf_file)) {
                  let href = row.xlstopsf_file.replace(/\\/g, "/");
                  var xlsfileurl=window.location.host;
                  if(xlsfileurl=="47.100.58.231:8091" || xlsfileurl=="192.168.0.2:8091"){
                    that.pdfurl = Common.FileUrl+'/file/' + href;
                  }
                  else{
                    that.pdfurl =Common.InUrl+'/file/'+href;
                  }
                  window.open(that.pdfurl,"_blank");
                }
            }
            else{
              //通过插件打开
              let that = this;
              let obj = null;
              let webshell = null;
              let origin=null;
              var t1 = "*@*";
              fileurl=window.location.host;
              if(fileurl=="47.100.58.231:8091"){
                origin=Common.FileUrl;
              }
              else{
                origin= window.location.origin+'/';
              }
              obj = t1 + row.doc_id + t1 + that.userData.username + t1 + row.doc_name + t1 + origin + that.FormatServerUrlFile(row.hash_value);
              webshell = 'Webshell://download' + obj;            
              if (!webshell) {
                return;
              }
              else{
                window.location.href = webshell;
              }
              
            }
          }
        }
      
      },
      downxls(data){
        let that=this;
          if (that.$limits.fnIsEmpty(data.row.xlstopsf_file)) {
            return;
          }
          console.log(data.row)
          
          let parm ={
            Id:data.row.doc_id,
            LangType:that.$processdata.getLang()
          }
          that.$http.urlpost('webdoc/doc/GetDownExecl', parm, function (res) {
              if (res.Success == 1) {
                var xlstopsf_file=res.DataContent.URL;
                if(data.row.hash_value.toLowerCase().includes('.xls') || data.row.hash_value.toLowerCase().includes('.xlsx')){
                  //execl 文件通过转换成PDF查看 并增加下载EXECL功能
                  if (!that.$limits.fnIsEmpty(xlstopsf_file)) {
                    let href = xlstopsf_file.replace(/\\/g, "/");
                    var xlsfileurl=window.location.host;
                    if(xlsfileurl=="47.100.58.231:8091" || xlsfileurl=="192.168.0.2:8091"){
                      that.pdfurl = Common.FileUrl+'/file/' + href;
                    }
                    else{
                      that.pdfurl =Common.InUrl+'/file/'+href;
                    }
                    window.open(that.pdfurl,"_blank");
                  }
                }
                 
              }
          });
      },
      downdcc(data){
        let that=this;
          if (data.row.doc_type.toLowerCase()!='.pdf' && data.row.doc_type.toLowerCase()!='.xls' && data.row.doc_type.toLowerCase()!='.xlsx'){
              return;
          }          
          let parm ={
            doc_id:data.row.doc_id,
            LangType:that.$processdata.getLang()
          }
          that.$http.urlpost('webdoc/doc/downdccfile', parm, function (res) {
              if (res.Success == 1) {
                  var xlstopsf_file=res.DataContent.fileURL;                  
                    var xlsfileurl=window.location.host;
                    if(xlsfileurl=="47.100.58.231:8091" || xlsfileurl=="192.168.0.2:8091"){
                      that.pdfurl = Common.FileUrl+'/file/' + xlstopsf_file;
                    }
                    else{
                      that.pdfurl =Common.InUrl+'/file/' +xlstopsf_file;
                    }
                    window.open(that.pdfurl,"_blank");
                }
          });
      },
      lct(row){
        let that = this;
        if (!row) {
          return;
        }
        let msgText = '';
        let p1 = { 
          url: null, 
          doc_id: row.row.doc_id, 
          Token: that.mytoken() 
        };
        p1.url = '/webdoc/doc/RejectRelease';
        msgText = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11844]')+'</span>？<br/>' + row.row.doc_name;
        //请确认，是否要对文件/驳回至审核中待替换状态
        that.$confirm(msgText, that.$t('getapi[194]'), {
            confirmButtonText: that.$t('getapi[1146]'),
            cancelButtonText: that.$t('getapi[2054]'),
            type: 'warning',
            dangerouslyUseHTMLString: true
        })
          .then(() => {
            that.loading = true;
            that.$http.urlpost(p1.url, p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                  that.refreshGridRow(that.searchHJ.dataSet, res.DataContent)
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error( that.$t('getapi[9874]'));//"操作失败！"
          });
      },
      fmtDocNameColor: function (row) {
        let colorText = null;
        // QE替换
        if (!row) {
          return colorText;
        }

        if (row.qc_flag > 0) {
          colorText = { color: 'green' };
        } else if (row.qc_flag == 0) {
          colorText = { color: 'red' };
        }
        else {
          if (row.hash_value) {
            colorText = { color: 'blue' };
          }
        }
        return colorText;
      },
      tableRowClassName({row, rowIndex}) {
        row.index = rowIndex;
        if (row.dcc_replace=="ECN") {
            return 'yellow';
        }
      },
      fnFmtPDFZip_New(hash_value) {
        console.log("测试下载")
        if (!hash_value) {
          return null;
        }
        if (hash_value.indexOf("http://") != -1) {
          window.open(  hash_value);
        }
        if (window.location.href.indexOf('localhost') != -1) {
          window.open( "http://localhost/file/" + hash_value);
        }
        else {
          let href = hash_value.replace(/\\/g, "/");
          if(this.loadfileurl=="47.100.58.231:8091" || this.loadfileurl=="192.168.0.2:8091"){
            window.open( Common.FileUrl+'/file/' + href)
          }
          else{
            window.open( Common.InUrl+'/file/'+href)
          }
        }
        console.log("测试下载AA");
      },
      fnFmtPDFZip(hash_value) {
        if (!hash_value) {
          return null;
        }
        if (hash_value.indexOf("http://") != -1) {
          return  hash_value;
        }
        if (window.location.href.indexOf('localhost') != -1) {
          // return "http://localhost:8080/file/" + hash_value;
          // IIS-DEBUG
          return "http://localhost/file/" + hash_value;
        }
        else {
          let href = hash_value.replace(/\\/g, "/");
          if(this.loadfileurl=="47.100.58.231:8091" || this.loadfileurl=="192.168.0.2:8091"){
            return Common.FileUrl+'/file/' + href;
          }
          else{
            return Common.InUrl+'/file/'+href;
          }
          // return "/file/" + hash_value;
        }
      },
      rowStyler6({ row, column, rowIndex, columnIndex }) {
        if (columnIndex == 0 && this.fnIntToNull(row.privilege_value) > 1) {
          return 'myVersion';
        }
        if (columnIndex == 2 && this.fnIntToNull(row.doc_count) > 1) {
          return 'rowStyler6';
        }

        return '';
      },
      fileClear6(row) {
        if (!row) {
          return;
        }
        row.docName2 = null;
        row.file = null;
        row.enable_flag_text = "";

      },
      fileDel6(row) {
        // 删除文件
        let that = this;
        console.log(111111)
        if (!row) {
          return;
        }
        let rowIndex = -1;
        let rows = that.search1.dataSet;
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].doc_id == row.doc_id && row.doc_id > 0) {
            rowIndex = i;
            break;
          }
        }

        that.$confirm(that.$t('getapi[11845]')+'<br/>'+that.$t('getapi[3590]')+':' + row.doc_name, that.$t('getapi[194]'), {
            //请确认，是否要进行删除操作/文件名
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            that.loading = true;
            let p1 = { doc_id: row.doc_id, Token: that.mytoken() };
            that.$http.urlpost('webdoc/doc/delete', p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                if (rowIndex > 0) {
                  rows.splice(rowIndex, 1);
                }
                else {
                  that.showGrid1(1);
                }
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[3819]'));//"删除失败!"
          });
      },
      formatterTdept(row) {
        let that = this;
        let obj = null;
         for(let i=0 ;i< that.DeptCombox.length;i++){
           if(that.DeptCombox[i].Code==row.id_dept){
             obj=that.DeptCombox[i].Name;
             break;
           }
         }
        return obj;
      },
      formatterTItem(row) {
        let that = this;
        let obj = null;
         for(let i=0 ;i< that.ItemCombox.length;i++){
           if(that.ItemCombox[i].Code==row.id_type){
             obj=that.ItemCombox[i].Name;
             break;
           }
         }
        return obj;
      },

      formatterT1(row) {
        let that = this;
        let obj = null;
        let href = [];
        if (row.docName2) {
          obj = { text: '清除', click: function () { that.fileClear6(row); }, id: "", style: "color:blue;cursor:pointer;" };
          href.push(obj);
        }
        else {
          var enableFlag = row.enable_flag;
          if (enableFlag == -1 || enableFlag == -2) {
            // 只能删除已上传未审核的文档
            obj = { text: '删除', click: function () { that.fileDel6(row); }, id: "", style: "color:blue;cursor:pointer;" };
            href.push(obj);
          }
          else if (enableFlag == -5 || enableFlag == -6 || enableFlag == 3) {
            if (enableFlag == 3) {
              // 发布退回、审核退回、作废
              obj = { text: row.enable_flag_text, click: function () { }, id: "", style: null };
            }
            else {
              obj = { text: row.enable_flag_text, click: function () { }, id: "", style: "color:red;" };
            }
            href.push(obj);

            obj = { text: "删除", click: function () { that.fileDel6(row); }, id: "", style: "color:blue;cursor:pointer;" };
            href.push(obj);
          }
          else {
            obj = { text: row.enable_flag_text, click: function () { }, id: "", style: null };
            href.push(obj);
          }
        }
        for (let i = 0; i < href.length; i++) {
          href[i].id = "T1_" + i.toString();
        }
        return href;
      },
      formatterT2(row) {
        let that = this;
        let obj = null;
        let href = [];

         // 待上-2 已上传 -1 待审核 0 已审核 1 已发布 2 作废 3
         var enableFlag = row.enable_flag;
        if (enableFlag === 0) {
          // 只能删除已上传未审核的文档
          obj = { text: '通过', click: function () { that.fileAudit8_YesNoCancel(row, '通过'); }, id: "", style: "color:blue;cursor:pointer;" };
          href.push(obj);
          obj = { text: '拒绝', click: function () { that.fileAudit8_YesNoCancel(row, '拒绝'); }, id: "", style: "color:red;padding-left: 9px;cursor:pointer;" };
          href.push(obj);
        }
        else if (enableFlag === 1) {
          obj = { text: '反审', click: function () { that.fileAudit8_YesNoCancel(row, '反审'); }, id: "", style: "color:red;cursor:pointer;" };
          href.push(obj);
        }
        else {
          obj = { text: row.enable_flag_text, click: function () { }, id: "", style: null };
          href.push(obj);
        }
        for (let i = 0; i < href.length; i++) {
          href[i].id == "T2_" + i.toString();
        }
        return href;
      },
      formatterT3(row) { // 发布文件
        let that = this;
        let obj = null;
        let href = [];

        // 待上-2 已上传 -1 待审核 0 已审核 1 已发布 2 作废 3
        var enableFlag = row.enable_flag;
        if (enableFlag === 1) {
          if (!that.fnToNull(row.part_list)) {
            obj = { text: "缺编码", click: function () { }, id: "", style: "color:red;" };
            href.push(obj);
          }
          else {
            if (row.qc_flag == 0) {
              obj = { text: "待替换", click: function () { }, id: "", style: "color:green;" };
              href.push(obj);
            }
            else {
              obj = { text: '发布', click: function () { that.filePublish_YesNo(row, '发布'); }, id: "", style: "color:blue;cursor:pointer;" };
              href.push(obj);

            }
          }
          obj = { text: '拒绝', click: function () { that.filePublish_YesNo(row, '拒绝'); }, id: "", style: "color:red;padding-left: 9px;cursor:pointer;" };
          href.push(obj);
        }
        else if (enableFlag === 2) {
          // 手动作废
          obj = { text: '作废', click: function () { that.filePublish_YesNo(row, '作废'); }, id: "", style: "color:red;cursor:pointer;" };
          href.push(obj);
        }
        else if (enableFlag == 3) {
          // 作废
          obj = { text: row.enable_flag_text, click: function () { }, id: "", style: null }
          href.push(obj);
          obj = { text: '删除', click: function () { that.filePublish_YesNo(row, '删除'); }, id: "", style: "color:blue;padding-left: 9px;cursor:pointer;" };
          href.push(obj);
        }
        else {
          obj = { text: row.enable_flag_text, click: function () { }, id: "", style: null };
          href.push(obj);
        }

        for (let i = 0; i < href.length; i++) {
          href[i].id = "T3_" + i.toString();
        }
        return href;
      },
      //焊接图
      formatterT4(row) { 
        let that = this;
        let obj = null;
        let href = [];
        // console.log("用户:"+JSON.stringify(this.userData))
        if (row == null) {
          return "";
        }
        if (!row.hash_value) {
          return "";
        }

        if(that.userData.Login_DB.toLowerCase()=="xz" || that.userData.Login_DB.toLowerCase()=="test" ){
            // 只能删除已上传未审核的文档
            obj = { text: '通过', click: function () { that.confirmHJ(row,1); }, id: "", style: "color:blue;cursor:pointer;" };
            href.push(obj);
            obj = { text: '拒绝', click: function () { that.confirmHJ(row,0); }, id: "", style: "color:red;padding-left: 9px;cursor:pointer;" };
            href.push(obj);
        }
        else{
          if (row.vss_flag == -1) {
              obj = { text: '编辑中', click: function () { that.editPDF(row, '编辑中'); }, id: "", style: "color:blue;cursor:pointer;" };
              href.push(obj); 
          }
          else if (row.vss_flag == 1) {
              obj = { text: '编辑', click: function () { that.editPDF(row, '编辑'); }, id: "", style: "color:blue;cursor:pointer;" };
              href.push(obj);
          }
          else {
            obj = { text: '在线编辑', click: function () { that.editPDF(row, '在线编辑'); }, id: "", style: "color:blue;cursor:pointer;" };
            href.push(obj);
          }
        }
        return href;
      },
      FormatServerUrlFile(url) {
        return 'file/' + url;
      },
      
      editPDF(row,txt) {
        let that = this;
        let obj = null;
        let webshell = null;
        let origin=null;
        var t1 = "*@*";
        var fileurl=window.location.host;
        if(fileurl=="47.100.58.231:8091"){
          origin=Common.FileUrl;
        }
        else{
          origin= window.location.origin+'/';
        }
        // console.log("测试111:"+origin)
        obj = t1 + row.doc_id + t1 + that.userData.username + t1 + row.doc_name + t1 + origin + that.FormatServerUrlFile(row.hash_value);
        
        if(txt=="编辑中"){
          webshell = 'Webshell://save' + obj;
        }
        if(txt=="编辑"){
          webshell = 'Webshell://open' + obj;
        }
        if(txt=="在线编辑"){
          webshell = 'Webshell://open' + obj;
        }
        if (!webshell) {
          return;
        }
        if (webshell.indexOf('Webshell://save') > -1) {
            that.$confirm(that.$t('getapi[11846]'), that.$t('getapi[194]'), {//'请确认，是否要上传文件？(确保本地PDF文件已保存并关闭)'
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                        .then(() => {
                          window.location.href =encodeURI(webshell);
                          var t = setTimeout(
                            function () {
                              that.showGrid1(1);
                            }
                            , 2000);
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
          
        }
        else {
          window.location.href = webshell;
          var t = setTimeout(
              function () {
                that.showGrid1(1);
              }
              , 2000);
        }
      },
      deleteGridRows(dataSet, doc_id) {
        let that = this;
        if (!dataSet || !doc_id) {
          return;
        }
        for (let i = 0; i < dataSet.length; i++) {
          if (dataSet[i].doc_id == doc_id) {
            dataSet.splice(i, 1);
            return;
          }
        }
      },
      refreshGridRow(dataSet, newRow) {
        let that = this;
        if (!dataSet || !newRow) {
          that.showGrid1(1);
          return;
        }
        for (let i = 0; i < dataSet.length; i++) {
          if (dataSet[i].doc_id == newRow.doc_id) {
            dataSet.splice(i, 1, newRow);
            return;
          }
        }
        that.showGrid1(1);
      },      
      confirmHJ(row,enable_flag) {
                // 审核通过
        let that = this;  
        // if (type == 0) {      
        //   if (!that.fnToNull(that.hj_reason)) {
        //     that.$message.error(that.$t('getapi[11847]'));//"请输入拒绝原因！"
        //     return;
        //   }
        // }
        let p1 = {
          msg: null,
          url: 'webdoc/doc/WeldAudit',
          doc_id: row.doc_id,
          Token: that.mytoken(),
          enable_flag: null,
          doc_name: row.doc_name,
          // hj_reason:that.hj_reason,
        };

        if (enable_flag ==1) {
          p1.msg = that.$t('getapi[11806]')+'<span style="color: blue;">'+that.$t('getapi[11848]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + p1.doc_name;
          ///请确认，是否要对文件/审核通过/操作
          p1.enable_flag = 1;
        } else if (enable_flag == 0) {
          p1.msg = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11849]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + p1.doc_name;
          //请确认，是否要对文件/拒绝通过/操作
          p1.enable_flag = -2;
        }
        else {
          return;
        }
        that.$confirm(p1.msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            // 审核、拒接文件
            that.loading = true;
            that.$http.urlpost(p1.url, p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                that.hjVisiable=false;
                that.showGrid1(1);
                // that.refreshGridRow(that.searchHJ.dataSet, res.DataContent)
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[1457]'));//"审核失败！"
          });
      },
      ///焊接图审批
      WeldAudit(row, text) {
        let that=this;
        that.hj_reason="";
        that.hj_doc_id=row.doc_id;
        that.hj_doc_name=row.doc_name;
        that.hjVisiable=true;
      },
      fileAudit8_YesNoCancel(row, text) {
        // 审核通过
        let that = this;
        if (!row) {
          return;
        }

        let p1 = {
          msg: null,
          url: 'webdoc/doc/audit',
          doc_id: row.doc_id,
          Token: that.mytoken(),
          enable_flag: null,
          doc_name: row.doc_name
        };

        if (text == '通过') {
          p1.msg = that.$t('getapi[11806]')+'<span style="color: blue;">'+that.$t('getapi[11848]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + p1.doc_name;
          //请确认，是否要对文件/审核通过/操作
          p1.enable_flag = 1;
        } else if (text == '拒绝') {
          p1.msg = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11849]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + p1.doc_name;
          //请确认，是否要对文件/拒绝通过/操作
          p1.enable_flag = 0;
        }
        else if (text == '反审') {
          p1.msg = that.$t('getapi[11850]')+'<br/>'+that.$t('getapi[3590]')+':' + p1.doc_name;
          //请确认，是否要进行反审操作/文件名
          p1.url = 'webdoc/doc/auditCancel';
        }
        else {
          return;
        }
        that.$confirm(p1.msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            // 审核、反审文件
            that.loading = true;
            that.$http.urlpost(p1.url, p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                that.refreshGridRow(that.search2.dataSet, res.DataContent)
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[4085]'));//"审核失败！"
          });
      },
      filePublish_Yes(row) {
        let that = this;
        if (!that.fnToNull(row.part_list)) {
          that.$message.error(that.$t('getapi[11851]'));//"缺少物料编码不能发布"
          return;
        }
        let p1 = { doc_id: row.doc_id, Token: that.mytoken() };
        // 检查是否存在已发布版本
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/existsPublish', p1, function (res) {
          that.loading = false;

          if (res.Success < 0) {
              that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
            return;
          }

          let msgText = that.$t('getapi[11852]')+'<span style="color:red">' + row.doc_name + '</span>？';//请确认，是否发布
          if (res.DataContent.N > 0) {
            msgText = msgText + '<br/>'+ that.$t('getapi[11853]');//(已发布的版本将自动作废)
          }
          if (row.part_list.indexOf(',') > 0) {
            msgText = msgText + '<br/>(<span style="color:red">'+that.$t('getapi[11853]')+'</span>)';//存在多个物料编码
          }

          // 发布
          that.$confirm(msgText, that.$t('getapi[194]'), {
            confirmButtonText: that.$t('getapi[1146]'),
            cancelButtonText: that.$t('getapi[2054]'),
            type: 'warning',
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              // 发布文件
              that.loading = true;
              p1.enable_flag = 1;
              that.$http.urlpost('/webdoc/doc/publish', p1, function (res) {
                that.loading = false;
                if (res.Success > 0) {
                  that.$message.success(that.$t('getapi[11804]'));//"发布成功！"
                  that.refreshGridRow(that.search3.dataSet, res.DataContent)
                }
                else {
                  //that.$message.error(res.Msg);
                  that.$alert(that.$processdata.explainCallbackMsg(res.Msg), '', {
                    dangerouslyUseHTMLString: true, center: true,
                    callback: action => {
                      return;
                    }
                  });
                }
              });
            })
            .catch(action => {
              if (action == "cancel") {
                return;
              }
              that.$message.error(that.$t('getapi[11805]'));//"发布失败！"
            });
        });
      },
      AuditChangeEnableFlag(){
        // 审核页签-文件状态发生变化事件处理
        let that=this;
        that.audit_pass=false;//审核 通过
        that.audit_refuse=false;//审核 拒绝
        that.audit_deapproval=false;//审核 反审

        if(that.search2.enable_flag==0 && that.selectDataAudit.length>0)
        {
          that.audit_pass=true;//审核 通过
          that.audit_refuse=true;//审核 拒绝
        }
        if(that.search2.enable_flag==1 && that.selectDataAudit.length>0)
        {
          that.audit_deapproval=true;//审核 反审
        }
      },
      PulishChangeEnableFlag(){
          // 审核页签-文件状态发生变化事件处理
        let that=this;
        that.publish_pass=false;//发布 通过
        that.publish_refuse=false;////发布 拒绝
        that.publish_void=false;////发布 作废

        if(that.search3.enable_flag==1 && that.selectDataPublish.length>0)
        {
          that.publish_pass=true;//发布 通过
          that.publish_refuse=true;//发布 拒绝
        }
        if(that.search3.enable_flag==2 && that.selectDataPublish.length>0)
        {
          that.publish_void=true;//发布 作废
        }
      },
      
      // 勾选发布
      handleSelectionChangePublish(val) {
        // 明细选择
        let that = this;
        that.selectDataPublish = [];
        for (let i = 0; i < val.length; i++) {
          that.selectDataPublish.push(val[i]);
        }
        that.PulishChangeEnableFlag();
      },      
      BatchPublish(text){
          let that=this;
          if(that.selectDataPublish.length==0){
            return;
          }
          let p1 = {
            msg: null,
            list: that.selectDataPublish,
            Token: that.mytoken(),
            enable_flag: null
          };
          if (text == '发布') {
          p1.msg = that.$t('getapi[11806]')+'<span style="color: blue;">'+that.$t('getapi[11848]')+'</span>'+that.$t('getapi[6048]')+'<br/>';
          //请确认，是否要对文件/审核通过/操作
          p1.enable_flag = 1;
        } 
        else {
          return;
        }
          that.$confirm(p1.msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
          // 检查是否存在已发布版本
          that.loading = true;
            that.$http.urlpost('/webdoc/doc/BatchExistsPublish', p1, function (res) {
              that.loading = false;
              if (res.Success < 0) {
                  that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                return;
              }
              let msgText = that.$t('getapi[11852]')+'？';//请确认，是否发布
              if (!that.$limits.fnIsEmpty(res.DataContent.N)) {
                msgText = msgText + '<br/>'+res.DataContent.N+ that.$t('getapi[11853]');//(已发布的版本将自动作废)
              }
              if (!that.$limits.fnIsEmpty(res.DataContent.N)) {
                msgText = msgText + '<br/>(<span style="color:red">'+res.DataContent.N+that.$t('getapi[11853]')+'</span>)';//存在多个物料编码
              }
              // 发布
              that.$confirm(msgText, that.$t('getapi[194]'), {
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning',
                dangerouslyUseHTMLString: true
              })
                .then(() => {
                  // 发布文件
                  that.loading = true;
                  that.$http.urlpost('/webdoc/doc/BatchPublish', p1, function (res) {
                    that.loading = false;
                    if (res.Success > 0) {
                      that.$message.success(that.$t('getapi[11804]'));//"发布成功！"
                      that.refreshGridRow(that.search3.dataSet, res.DataContent)
                    }
                    else {
                      that.$alert(that.$processdata.explainCallbackMsg(res.Msg), '', {
                        dangerouslyUseHTMLString: true, center: true,
                        callback: action => {
                          return;
                        }
                      });
                    }
                  });
                })
                .catch(action => {
                  if (action == "cancel") {
                    return;
                  }
                  that.$message.error(that.$t('getapi[11805]'));//"发布失败！"
                })
            })
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[11805]'));//"发布失败！"
          });
      },
      BatchPublishCancel(text){
          let that=this;
          if(that.selectDataPublish.length==0){
            return;
          }
          let p1 = {
            msg: null,
            list: that.selectDataPublish,
            Token: that.mytoken(),
            enable_flag: null
          };
          if (text == '拒绝') {
            p1.msg = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11849]')+'</span>'+that.$t('getapi[6048]')+'<br/>';
            //请确认，是否要对文件/拒绝通过/操作
            p1.enable_flag = 0;
          }
          else if (text == '作废') {
            p1.msg = that.$t('getapi[12339]');
            //请确认，是否要进行反审操作/文件名
            p1.enable_flag = -2;
          }
          else {
            return;
          }
          that.$confirm(p1.msg, that.$t('getapi[194]'), {
            confirmButtonText: that.$t('getapi[1146]'),
            cancelButtonText: that.$t('getapi[2054]'),
            type: 'warning',
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              // 发布文件
              that.loading = true;
              that.$http.urlpost('/webdoc/doc/BatchPublish', p1, function (res) {
                that.loading = false;
                if (res.Success > 0) {
                  that.$message.success(that.$t('getapi[11804]'));//"发布成功！"
                  that.refreshGridRow(that.search3.dataSet, res.DataContent)
                }
                else {
                  that.$alert(that.$processdata.explainCallbackMsg(res.Msg), '', {
                    dangerouslyUseHTMLString: true, center: true,
                    callback: action => {
                      return;
                    }
                  });
                }
              });
            })
            .catch(action => {
              if (action == "cancel") {
                return;
              }
              that.$message.error(that.$t('getapi[11805]'));//"发布失败！"
            })
          
      },
      VoidBatchPublishCancel(text){
          let that=this;
          if(that.search5.multipleSelection.length==0){
            return;
          }
          let p1 = {
            msg: null,
            list: that.search5.multipleSelection,
            Token: that.mytoken(),
            enable_flag: null
          }; 
          if (text == '作废') {
            p1.msg = that.$t('getapi[12339]');
            //请确认，是否要进行反审操作/文件名
            p1.enable_flag = -2;
          }
          else {
            return;
          }
          that.$confirm(p1.msg, that.$t('getapi[194]'), {
            confirmButtonText: that.$t('getapi[1146]'),
            cancelButtonText: that.$t('getapi[2054]'),
            type: 'warning',
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              // 发布文件
              that.loading = true;
              that.$http.urlpost('/webdoc/doc/BatchPublish', p1, function (res) {
                that.loading = false;
                if (res.Success > 0) {
                  that.$message.success(that.$t('getapi[11804]'));//"发布成功！"
                  that.refreshGridRow(that.search3.dataSet, res.DataContent)
                }
                else {
                  that.$alert(that.$processdata.explainCallbackMsg(res.Msg), '', {
                    dangerouslyUseHTMLString: true, center: true,
                    callback: action => {
                      return;
                    }
                  });
                }
              });
            })
            .catch(action => {
              if (action == "cancel") {
                return;
              }
              that.$message.error(that.$t('getapi[11805]'));//"发布失败！"
            })
          
      },
      // 勾选审核
      handleSelectionChangeAudit(val) {
        // 明细选择
        let that = this;
        that.selectDataAudit = [];
        for (let i = 0; i < val.length; i++) {
          that.selectDataAudit.push(val[i]);
        }
        that.AuditChangeEnableFlag();
      },
      BatchAudit(text){
          let that=this;
          if(that.selectDataAudit.length==0){
            return;
          }
          let p1 = {
          msg: null,
          url: 'webdoc/doc/BatchAudit',
          list: that.selectDataAudit,
          Token: that.mytoken(),
          enable_flag: null
        };
        if (text == '通过') {
          p1.msg = that.$t('getapi[11806]')+'<span style="color: blue;">'+that.$t('getapi[11848]')+'</span>'+that.$t('getapi[6048]')+'<br/>';
          //请确认，是否要对文件/审核通过/操作
          p1.enable_flag = 1;
        } else if (text == '拒绝') {
          p1.msg = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11849]')+'</span>'+that.$t('getapi[6048]')+'<br/>';
          //请确认，是否要对文件/拒绝通过/操作
          p1.enable_flag = 0;
        }
        else if (text == '反审') {
          p1.msg = that.$t('getapi[11850]');
          //请确认，是否要进行反审操作/文件名
          p1.enable_flag = -2;
        }
        else {
          return;
        }
          that.$confirm(p1.msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            // 审核、反审文件
            that.loading = true;
            that.$http.urlpost(p1.url, p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                that.refreshGridRow(that.search2.dataSet, null)
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[4085]'));//"审核失败！"
          });
      },
      filePublish_YesNo(row, text) {
        let that = this;
        if (!row) {
          return;
        }
        let msgText = '';
        let p1 = { url: null, doc_id: row.doc_id, Token: that.mytoken() };

        if (text == '发布') {
          that.filePublish_Yes(row);
          return;
        } else if (text == '作废') {
          p1.url = '/webdoc/doc/destroy';
          msgText = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[1902]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + row.doc_name;
          //请确认，是否要对文件/作废/操作？
        }
        else if (text == '删除') {
          msgText = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[40]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + row.doc_name;
          p1.url = 'webdoc/doc/delete';
        }
        else if (text == '拒绝') {
          msgText = that.$t('getapi[11806]')+'<span style="color:red">'+that.$t('getapi[11807]')+'</span>'+that.$t('getapi[6048]')+'<br/>' + row.doc_name;
          p1.url = 'webdoc/doc/publish';
          p1.enable_flag = 0;
        }
        else {
          return;
        }

        that.$confirm(msgText, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {

            that.loading = true;
            that.$http.urlpost(p1.url, p1, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                if (text == '删除') {
                  that.deleteGridRows(that.search3.dataSet, p1.doc_id);
                }
                else {
                  that.refreshGridRow(that.search3.dataSet, res.DataContent)
                }
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[9874]'));//"操作失败！"
          });
      },
      fnFmtDate(d) {
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = d.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        return year + "-" + month + "-" + day;
      },
      fnIntToNull(obj) {
        if (obj === undefined || typeof (obj) == "undefined") {
          return null;
        }
        if (obj == "") {
          return null;
        }
        return parseInt(obj);
      },
      fnToNull(obj) {
        if (obj === null || obj === "") {
          return null;
        }
        if (typeof (obj) === undefined || typeof (obj) == "undefined") {
          return null;
        }
        return obj;
      },
      tableRowClassNameNot({ row, rowIndex }) {
        row.index = rowIndex;
      },
        //tyep:1普通查询2：扫码查询
      showGrid1(type) {
        let that = this;        
        let search1 = null;
        let curSearch = null;
        let p1 = {
          url: '/webdoc/doc/findLists',
          Token: that.mytoken(),
          Soter: "root_id,node_id,doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,

          root_id: null,
          node_id: null,
          doc_name: null,

          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          doc_version:null,
          subDirectory: null,  //包含子目录
          searchPart: null,
          searchGroup: null,
          prosheetnum:null,
          dcc_Directory:null,
          qem_Directory:null,
          part_status:null,
          create_time:null,
          shareflag:null,//共享数据
          FuzzyQuery:0,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }

        if (that.activeName == that.search1.title) {
          //上传清单
          curSearch = that.search1;
          if (curSearch.enable_flag == -1 || curSearch.enable_flag == -2) {
            // 查询清单
            p1.url = '/webdoc/doc/findTempList';
            p1.Soter = "doc_id";
            p1.upload_person_id = that.userData.Login_Code;
          }
          else {
            //检索文件夹
            p1.url = '/webdoc/doc/findLists'
          }
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);

        } else if (that.activeName == that.search2.title) {
          //审核文件
          p1.url = '/webdoc/doc/findAuditList'
          curSearch = that.search2;
          p1.Soter="root_id,node_id,doc_name";
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        }
        else if (that.activeName == that.search3.title) {
          //发布文件
          curSearch = that.search3;

          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
          p1.item_type = that.fnToNull(curSearch.item_type);
          p1.part_status=curSearch.part_status;
          p1.create_time=curSearch.create_time;

        }
        else if (that.activeName == that.search4.title) {
          //文件一览
          curSearch = that.search4;
          if (curSearch.shareflag) {
            p1.shareflag = "1";
          }
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.part_list = that.fnToNull(curSearch.part_list);
          p1.group_list = that.fnToNull(curSearch.group_list);
          p1.item_type = that.fnToNull(curSearch.item_type);
          p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
          p1.node_name = that.fnToNull(curSearch.node_name);
          p1.qc_flag=that.fnToNull(curSearch.qc_flag);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
          p1.doc_version = that.fnToNull(curSearch.doc_version);
          p1.prosheetnum = that.fnToNull(curSearch.prosheetnum);
          p1.part_status=that.fnToNull(curSearch.part_status);
          p1.create_time=that.fnToNull(curSearch.create_time);
        }
        else if (that.activeName == that.search5.title) {
          //批量检索
          curSearch = that.search5;

          p1.url = '/webdoc/doc/findListsBatch'
          p1.enable_flag = 2; //已发布
          if(!that.search5.searchRoot){
            p1.node_id = -1;
          }
          if (curSearch.searchGroup) {
            p1.searchGroup = "1";
          }
          if (curSearch.searchPart) {
            p1.searchPart = "1";
          }

          let nbtText = "";
          if (curSearch.cb10_nbt) {
            nbtText = nbtText + "内部图\n";
          }
          if (curSearch.cb10_kht) {
            nbtText = nbtText + "客户图\n";
          }
          if (curSearch.cb10_cgj) {
            nbtText = nbtText + "采购件\n";
          }
          p1.nbtText = that.fnToNull(nbtText);

          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.item_type = that.fnToNull(curSearch.item_type);
          p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
          p1.part_status=that.fnToNull(curSearch.part_status);
          if (curSearch.PublishDateTimeStart) {
            p1.PublishDateTimeStart = that.fnFmtDate(curSearch.PublishDateTimeStart) + " 00:00:00";
          }
          if (curSearch.PublishDateTimeEnd) {
            p1.PublishDateTimeEnd = that.fnFmtDate(curSearch.PublishDateTimeEnd) + " 23:59:59";
          }
          // 打包下载
          that.zip5.href = null;
          if(that.search5.FuzzyQuery){
            p1.FuzzyQuery = 1;
          }
          
        }
        else if (that.activeName == that.searchHJ.title) {
          // 焊接图
          curSearch = that.searchHJ;
          p1.url = '/webdoc/doc/findListsQE';
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.node_name = that.fnToNull(curSearch.node_name);

          p1.qc_flag = that.fnToNull(curSearch.qc_flag);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        }
        else if (that.activeName == that.search6.title) {
          //工艺取号
          curSearch = that.search6;
          p1.url = '/webdoc/doc/GetNumList';
          p1.Soter= " action_time desc ";
          p1.id_text = that.fnToNull(curSearch.scraft);
          p1.id_item = that.fnToNull(curSearch.sitem);
          p1.id_type = that.fnToNull(curSearch.spro);
          p1.id_dept = that.fnToNull(curSearch.sdept);
        }else if (that.activeName == that.searchDCC.title) {
          //DCC
          curSearch = that.searchDCC;
          if (curSearch.Dcc) {
            p1.dcc_Directory = "1";
          }
          if (curSearch.shareflag) {
            p1.shareflag = "1";
          }
          
          p1.Soter=" publish_time desc,upload_person_name desc ";
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.part_list = that.fnToNull(curSearch.part_list);
          p1.group_list = that.fnToNull(curSearch.group_list);
          p1.item_type = that.fnToNull(curSearch.item_type);
          p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
          p1.node_name = that.fnToNull(curSearch.node_name);
          p1.qc_flag=that.fnToNull(curSearch.qc_flag);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
          p1.doc_version = that.fnToNull(curSearch.doc_version);
          p1.prosheetnum = that.fnToNull(curSearch.prosheetnum);
        }
        else if(that.activeName == that.searchQEM.title){
          //searchQEM
          curSearch = that.searchQEM;
          if (curSearch.QEM) {
            p1.qem_Directory = "1";
          }
          p1.Soter=" publish_time desc,upload_person_name desc ";
          p1.doc_name = that.fnToNull(curSearch.doc_name);
          p1.part_list = that.fnToNull(curSearch.part_list);
          p1.group_list = that.fnToNull(curSearch.group_list);
          p1.item_type = that.fnToNull(curSearch.item_type);
          p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
          p1.node_name = that.fnToNull(curSearch.node_name);
          p1.qc_flag=that.fnToNull(curSearch.qc_flag);
          p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
          p1.doc_version = that.fnToNull(curSearch.doc_version);
          p1.prosheetnum = that.fnToNull(curSearch.prosheetnum);
        }
        else {
          return;
        }

        if (curSearch.searchSub) {
          p1.subDirectory = "1";
        }
        //
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        console.log('----------showGrid1---------', p1);
        that.$http.urlpost(p1.url, p1, function (res) {
          that.loading = false;
          //console.log(res);
          if (res.Success <= 0) {
            return;
          }
          curSearch.dataSet = res.DataContent;
          curSearch.Page = res.Page;
          curSearch.Page.DbTbNames = res.DbTbNames;
          if(type == 2){
              that.search4.prosheetnum = ''
          }
        });
      },

      exportdate(val){
        let that = this;
         that.$confirm(that.$t('getapi[11808]')+that.myPage.Totals+that.$t('getapi[11809]'), that.$t('getapi[194]'), {//"请确认是否要下载"/笔零件清单
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    if(val=='P'){
                      that.PartslistExport(val);
                    }
                    else if(val=='C'){
                      that.CraftlistExport(val);
                    }
                    else if(val=='W'){
                      that.GetExternalDoclistExport(val);
                    }
                    else if(val=='D'){
                      that.GetDCCDoclistExport();
                    }
                    else if(val=='Q'){
                      that.GetQEMDoclistExport();
                    }
                    else if(val=='N'){
                      that.GetNumExport();
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[2054]')
                    });
                });
      },
      PartslistExport() {
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          Soter: "doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,
          root_id: null,
          node_id: null,
          doc_name: null,
          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          subDirectory: null,  
          searchPart: null,
          searchGroup: null,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }
        
        curSearch = that.search4;

        p1.doc_name = that.fnToNull(curSearch.doc_name);
        p1.part_list = that.fnToNull(curSearch.part_list);
        p1.group_list = that.fnToNull(curSearch.group_list);
        p1.item_type = that.fnToNull(curSearch.item_type);
        p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
        p1.node_name = that.fnToNull(curSearch.node_name);

        p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        
        if (curSearch.searchSub) {
          p1.subDirectory = "1";
        }
        if (curSearch.shareflag) {
            p1.shareflag = "1";
        }
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetPartslistExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },
      CraftlistExport() {
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          Soter: "doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,
          root_id: null,
          node_id: null,
          doc_name: null,
          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          subDirectory: null,  
          searchPart: null,
          searchGroup: null,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }
        curSearch = that.search4;

        p1.doc_name = that.fnToNull(curSearch.doc_name);
        p1.part_list = that.fnToNull(curSearch.part_list);
        p1.group_list = that.fnToNull(curSearch.group_list);
        p1.item_type = that.fnToNull(curSearch.item_type);
        p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
        p1.node_name = that.fnToNull(curSearch.node_name);

        p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        
        if (curSearch.searchSub) {
          p1.subDirectory = "1";
        }
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetCraftlistExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },      
      GetExternalDoclistExport() {
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          Soter: "doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,
          root_id: null,
          node_id: null,
          doc_name: null,
          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          subDirectory: null,  
          searchPart: null,
          searchGroup: null,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }
        curSearch = that.search4;

        p1.doc_name = that.fnToNull(curSearch.doc_name);
        p1.part_list = that.fnToNull(curSearch.part_list);
        p1.group_list = that.fnToNull(curSearch.group_list);
        p1.item_type = that.fnToNull(curSearch.item_type);
        p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
        p1.node_name = that.fnToNull(curSearch.node_name);

        p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        
        if (curSearch.searchSub) {
          p1.subDirectory = "1";
        }
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetExternalDoclistExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },
      // DCC下载清单
      GetDCCDoclistExport() {
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          Soter: "doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,
          root_id: null,
          node_id: null,
          doc_name: null,
          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          subDirectory: null,  
          searchPart: null,
          searchGroup: null,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }
        curSearch = that.searchDCC;
        if (curSearch.shareflag) {
            p1.shareflag = "1";
        }
        p1.doc_name = that.fnToNull(curSearch.doc_name);
        p1.part_list = that.fnToNull(curSearch.part_list);
        p1.group_list = that.fnToNull(curSearch.group_list);
        p1.item_type = that.fnToNull(curSearch.item_type);
        p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
        p1.node_name = that.fnToNull(curSearch.node_name);

        p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        p1.dcc_Directory = "1";
        
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetDccDoclistExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },
      // 管理体系文件清单 下载
      GetQEMDoclistExport() {
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          Soter: "doc_name",
          MyDefined: null,
          Accurate: false,
          PageIndex: 1,
          PageSize: 10,
          root_id: null,
          node_id: null,
          doc_name: null,
          node_name: null,
          group_list: null,
          part_list: null,
          item_type: null,
          blueprint_no1: null,
          blueprint_no2: null,
          UploadStartTime: null,
          UploadEndTime: null,
          PublishDateTimeStart: null,
          PublishDateTimeEnd: null,
          doc_id: null,
          subDirectory: null,  
          searchPart: null,
          searchGroup: null,
        };
        if (that.curNode) {
          p1.node_id = that.curNode.node_id;
        }
        curSearch = that.searchQEM;

        p1.doc_name = that.fnToNull(curSearch.doc_name);
        p1.part_list = that.fnToNull(curSearch.part_list);
        p1.group_list = that.fnToNull(curSearch.group_list);
        p1.item_type = that.fnToNull(curSearch.item_type);
        p1.blueprint_no1 = that.fnToNull(curSearch.blueprint_no1);
        p1.node_name = that.fnToNull(curSearch.node_name);

        p1.enable_flag = that.fnIntToNull(curSearch.enable_flag);
        
        p1.PageSize = that.myPage.PageSize;
        p1.PageIndex = that.myPage.PageIndex;
        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetQEMDoclistExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },
      //工艺取号导出
      GetNumExport(){
        let that = this;
        let search1 = null;
        let curSearch = null;
        let p1 = {
          Token: that.mytoken(),
          id_text:'',
          id_dept:'',
          id_item :'',
          id_type :'',
        };
        p1.id_text=that.fnToNull(that.search6.scraft),
        p1.id_dept=that.fnToNull(that.search6.sdept), 
        p1.id_item =that.fnToNull(that.search6.sitem),
        p1.id_type =that.fnToNull(that.search6.spro),

        that.loading = true;
        that.$http.urlpost('/webdoc/doc/GetNumExport', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.Success == 1) {
              let hrefurl = Common.Url + res.DataContent.URL;
              window.open(hrefurl);
          }
        });
      },
      btnClick1(f) {
        let doc;
        if (f == "清单") {
          if(this.nodetype==3 ){
            this.$message.error(this.$t('getapi[13423]'));//"客户标准，请到外来文件中上传。"
            return;
          }
          doc = document.getElementById('file1');
          if (doc) {
            doc.click();
          }
        }
        else if (f == "文件") {
          doc = document.getElementById('file2');
          if (doc) {
            doc.click();
          }
        }
        else if (f == "上传") {
          this.search1.percentage = 1;
          this.uploadTempToServer(0, this.search1.dataSet);
        }
        else if (f == "清单检索") {
          doc = document.getElementById('file3');
          if (doc) {
            doc.click();
          }
        }
        else if (f == "焊接图") {
          doc = document.getElementById('tb2QCfile');
          if (doc) {
            doc.click();
          }
        } else if (f == "DXF") {
          doc = document.getElementById('tbDXFfile');
          if (doc) {
            doc.click();
          }
        }
        else if (f == "DWG") {
          doc = document.getElementById('tbDWGfile');
          if (doc) {
            doc.click();
          }
        }
        else {
          return;
        }
      },
      getSearch() {
        let curSearch = null;
        let that = this;
        if (that.activeName == that.search1.title) {
          //上传清单
          curSearch = that.search1;
          console.log('curSearch' + JSON.stringify(curSearch))

        } else if (that.activeName == that.search2.title) {
          //审核文件
          curSearch = that.search2;
        }
        else if (that.activeName == that.search3.title) {
          //发布文件
          curSearch = that.search3;

        }
        else if (that.activeName == that.search4.title) {
          //文件一览
          curSearch = that.search4;
        }
        else if (that.activeName == that.search5.title) {
          //批量检索
          curSearch = that.search5;
        }
        else if (that.activeName == that.search6.title) {
          //工艺取号
          curSearch = that.search6;
        }
        else if (that.activeName == that.searchDCC.title) {
          //DCC
          curSearch = that.searchDCC;
        }
        else if (that.activeName == that.searchQEM.title) {
          //QEM
          curSearch = that.searchQEM;
        }
        else {
          curSearch = null;
        }
        return curSearch;
      },
      currentChange(data, node) {
        this.PageIndex=1;
        this.myPage.PageIndex=1;
        this.curNode = data;
      },
      nodeClick(data, node) {

        let that = this;
        that.PageIndex=1;
        that.myPage.PageIndex=1;
        // 待编辑的文件移除后移除编辑效果
        if (that.isact != data) {
          that.isact = ''
          that.isUpdateGroup = false
        }
        if (data.node_id == 55 && data.node_name == "焊接图") {
          // 切换Tab
          console.log('-----nodeClick-----切换Tab--', data, node);
          that.activeName = that.searchHJ.title;
        }

        // this.curNode = data;
        if (data.isShowG) {
          that.showGrid1(1);
        }
        that.curNode = data
        if (!data.children) {
          that.$set(data, "children", []);
        } else {
          for (let i = 0; i < data.children.length; i++) {
            if (!data.children[i].children) {
              that.$set(data.children[i], "children", []);
            }
          }
        }
      },
      handlePreview() {
      },
      handleRemove() {
      },
      handleChange() {
      },
      handleSuccess() {
      },
      handleError() {
      },
      handleCurrentChange(no) {
        this.myPage.PageIndex = no;
        this.showGrid1(1);
      },
      handleSizeChange(size) {
          let that = this
        this.myPage.PageSize = size;
          if (that.activeName == that.search1.title) {
              console.log('换页')
              //上传清单
              this.$http.savePageSize('docmanageview',size)

          } else if (that.activeName == that.search2.title) {
              //审核文件
              this.$http.savePageSize('docmanageview2',size)
          }
          else if (that.activeName == that.search3.title) {
              //发布文件
              this.$http.savePageSize('docmanageview3',size)
          }
          else if (that.activeName == that.search4.title) {
              //文件一览
              this.$http.savePageSize('docmanageview4',size)
          }
          else if (that.activeName == that.search5.title) {
              //批量检索
              this.$http.savePageSize('docmanageview5',size)
          }
          else if (that.activeName == that.search6.title) {
              //工艺取号
              this.$http.savePageSize('docmanageview6',size)
          }
          else if(that.activeName == that.searchHJ.title){
              this.$http.savePageSize('docmanageview7',size)
          }
          else if(that.activeName == that.searchDCC.title){
              //DCC
              this.$http.savePageSize('docmanageview8',size)
          }
          else if(that.activeName == that.searchQEM.title){
              //QEM
              this.$http.savePageSize('docmanageview9',size)
          }
          
        this.showGrid1(1);
      },
      editInfo() {
      },
      leftt(e) {
        var left = document.getElementsByClassName("left");
        var mid = document.getElementsByClassName("mid");
        var Box = document.getElementsByClassName("Boxs");
        let bw = Box[0].clientWidth;
        if (e == 1) {
          left[0].style.width = "0px";
          mid[0].style.width = bw - 10 + "px";
        } else {
          left[0].style.width = bw - 50 + "px";
          mid[0].style.width = "0px";
        }
      },
      // 刷新
      reflash() {
        let that = this;
        that.getRootNode();
      },
      renderContent(h, { node, data, store }) {
        let that = this
        if (data.node_id == 55 && data.node_name == "焊接图") {
          return (
            <span class="custom-tree-node">
              <span class="text-red"> {node.label}</span>
            </span>
          );
        }
        else if (that.isact.node_id == data.node_id && that.isUpdateGroup == true) {
          return (
            <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; padding-right: 8px;">
              <span>
                <input type="text" onChange={this.handleChangeTitle.bind(this)} value={node.label} />
              </span>
            </span>
          );
        } else if (data.node_id == data.root_id) {
          return (
            <span class="custom-tree-node">
              <span class="myRootNode"> {node.label}</span>
            </span>
          );
        } else {
          return (
            <span class="custom-tree-node">
              <span> {node.label}</span>
            </span>
          );
        }
      },
      updateRenderContent(h, { node, data, store }) {
        let that = this
        return (
          <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; padding-right: 8px;" ><span>
            {that.isact.node_id == data.node_id ? (<input type="text" onChange={this.handleChangeTitle.bind(this)} value={node.label} />) :
              (<span>{node.label}</span>)
            }
          </span>
          </span>
        )
          ;
      },
      loadNode(node, resolve) {
        if (node.level === 0) {
          return resolve([]);
        }
        setTimeout(() => {
          let data = node.data;
          let that = this;
          that.nodetype=data.type;
          let parm = {
            Token: that.mytoken(),
            Accurate: false,
            PageIndex: 1,
            PageSize: 100,
            father_node_id: data.node_id,
            Soter: "node_name",
            type:'1,3',
          };

          that.$http.urlpost("/webdoc/folder/findList", parm, function (res) {
            if (res.Success <= 0) {
              return;
            }
            resolve(that.fmtLeaf(res.DataContent));
          });
        }, 300);
      },
      fmtLeaf(rows) {
        if (!rows) {
          return;
        }
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].N1 === 0 || rows[i].N1 == null) {
            rows[i].isShowG = true;
          }
        }

        return rows;
      },
      getRootNode() {
        // 获取BOM树数据
        let that = this;
        let parm = { 
          Token: that.mytoken(), 
          Accurate: false, 
          PageIndex: 1, 
          PageSize: 100,
          type:'1',
          spnodeid:'1541'
        };
        that.$http.urlpost("/webdoc/folder/findRoot", parm, function (res) {
          if (res.Success <= 0) {
            return;
          }
          that.dataTree = res.DataContent;

          that.defaultEexpandedkeys.push(res.DataContent[0].node_id);
          that.curNode = res.DataContent[0];
          // if (res.DataContent.length > 0) {
          //   setTimeout(() => {
          //     that.$refs.tree.setCurrentKey(res.DataContent[0].node_id);
          //     let node1 = that.$refs.tree.getNode(res.DataContent[0].node_id);
          //     that.defaultEexpandedkeys.push(node1.data.node_id)
          //   }, 500);
          // }
        });
      },
      getChildrenNode(data, node) {
        if (!node || !data) {
          return;
        }
        if (data.children.length > 0) {
          return;
        }
        //
        let that = this;
        that.nodetype=data.type;
        let parm = {
          Token: that.mytoken(),
          Accurate: false,
          PageIndex: 1,
          PageSize: 100,
          father_node_id: data.node_id,
          type:'1,3'
        };
        that.$http.urlpost("/webdoc/folder/findList", parm, function (res) {

          if (res.Success <= 0) {
            return;
          }
          data.children = res.DataContent;
          that.defaultEexpandedkeys = [
            ...that.defaultEexpandedkeys,
            data.node_id,
          ];
        });
      },
      // 选取树节点
      handleNodeClick(data, node) {
        let that = this;
        if (!data.children) {
          that.$set(data, "children", []);
        }
        that.getChildrenNode(data, node);
        that.defaultEexpandedkeys = [];
      },
      tabsHandleClick(tab) {
        // 切换Tabs
        let that = this
        if (that.activeName == that.search4.title || that.activeName == that.search5.title) {
            that.$refs.SetBtn.SetButtonEnable('')
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
        } else {
            that.$refs.SetBtn.SetButtonEnable('')
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', false);
        }
        that.$refs.SetBtn.SetButtonEnable('export',true);
        let curSearch = this.getSearch();
        if (curSearch == null) {
          return;
        }
        if (curSearch.dataSet == null) {
          //|| curSearch.dataSet.length == 0
          if (curSearch.title == this.search4.title || curSearch.title == this.search5.title) {
            if (this.curNode.isShowG) {
              this.showGrid1(1);
            }
          }
          else {
            this.showGrid1(1);
          }
        }
      },
      fileClear() {
        let doc = document.getElementById('file1');
        if (doc) {
          doc.value = null;
        }
        doc = document.getElementById('file2');
        if (doc) {
          doc.value = null;
        }
        doc = document.getElementById('file3');
        if (doc) {
          doc.value = null;
        }
        doc = document.getElementById('tb2QCfile');
        if (doc) {
          doc.value = null;
        }
        this.search1.info = null;
      },
      fnFileSize(size) {
        let unitArr = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        let index = 0;
        let quotient = parseFloat(size);
        while (quotient > 1024) {
          if (index >= unitArr.length) {
            break;
          }
          index += 1;
          quotient = quotient / 1024;
        }
        if (index === 0) {
          return quotient + ' ' + unitArr[index];
        } else {
          return quotient.toFixed(2) + ' ' + unitArr[index];
        }
      },
      fileXlsChange() {
        let that = this;
        
        that.search1.info = null;
        let doc = document.getElementById('file1');
        if (!doc) {
          return;
        }
        let files = doc.files;
        if (files == null) {
          return null;
        }
        if (files.length == 0) {
          return null;
        }

        if (!that.curNode) {
          //this.$message({ type: 'info', message: '已取消删除' });
          this.fileClear();
          that.$message.error(that.curNode.node_name + that.$t('getapi[11810]'));//"节点不正确，不能上传清单文件。"
          return;
        }
        // if (!that.curNode.father_node_id) {
        //   this.fileClear( );
        //   that.$message.error(that.curNode.node_name + "节点缺少父节点信息，不能上传清单文件。");
        //   return;
        // }
        if (!that.curNode.root_id) {
          this.fileClear();
          that.$message.error(that.curNode.node_name + that.$t('getapi[11811]'));//"节点缺少根目录信息，不能上传清单文件。"
          return;
        }

        // 检查
        that.loading = true;
        let p1 = { node_id: that.curNode.node_id, Token: that.mytoken(),LangType: that.$processdata.getLang() };
        that.$http.urlpost('webdoc/doc/checkUpload', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          let msg;
          if (res.DataContent.N1 > 0) {
            // 覆盖上传
            msg = res.DataContent.Info;
          }
          else {
            msg = that.$t('getapi[11741]')+'<br/>' + doc.files[0].name;//请确认,是否要上传清单？
          }

          // 上传清单
          var formData = new FormData();
          formData.append("node_id", that.curNode.node_id);
          formData.append("file", files[0]);
          formData.append("Token", that.mytoken());
          formData.append("LangType", that.$processdata.getLang());
          that.uploadCategoryFile(msg, formData);
        });

        return;
      },
      filePdfChange() {
        let that = this;
        that.search1.info = null;
        let doc = document.getElementById('file2');
        if (!doc) {
          return;
        }
        let fileRows = doc.files;
        if (fileRows == null) {
          return null;
        }
        if (fileRows.length == 0) {
          return null;
        }
        let gridRows = that.search1.dataSet;
        if (gridRows == null || gridRows.length == 0) {
          that.$message.error(that.$t('getapi[11812]'));//'缺少清单列表，不能选择上传文件。'
          that.fileClear();
          return;
        }

        let nOK = 0;
        let i = 0;
        let j = 0;
        for (i = 0; i < gridRows.length; i++) {
          for (j = 0; j < fileRows.length; j++) {
            // 名称相同
            if (gridRows[i].doc_name.toLowerCase() == fileRows[j].name.toLowerCase()) {
              gridRows[i].enable_flag_text = '待上传';
              gridRows[i].remark = that.fnFileSize(fileRows[j].size);

              gridRows[i].docName2 = fileRows[j].name;
              gridRows[i].file = fileRows[j];
              nOK = nOK + 1;
              break;
            }
          }
        }

        let nOKTotal = 0;
        for (i = 0; i < gridRows.length; i++) {
          if (gridRows[i].docName2) {
            nOKTotal = nOKTotal + 1;
          }
        }
        that.fileClear();

        if (nOKTotal == gridRows.length) {
          let msg = that.$t('getapi[11813]')+"<br/>"+that.$t('getapi[11814]')+"：<sapn class='text-red'>" + nOKTotal + '<span>'+that.$t('getapi[11753]');
          //请确认，是否自动上传文件?/总匹配/个文件
          that.$confirm(msg, that.$t('getapi[194]'), {
            confirmButtonText: that.$t('getapi[1146]'),
            cancelButtonText: that.$t('getapi[2054]'),
            type: 'warning',
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              var t = setTimeout(
                function () {
                  that.search1.percentage = 1;
                  that.uploadTempToServer(0, gridRows);
                }
                , 100);
            })
            .catch(action => {
              that.fileClear();
            });
        }
        else {
          that.search1.info = that.$t('getapi[201]') + gridRows.length + that.$t('getapi[11753]')+','+that.$t('getapi[11814]') + nOKTotal + that.$t('getapi[11753]');
          //共/个文件/总匹配/个文件
        }
      },
      uploadCategoryFile(msg, formData) {
        // 上传清单文件
        let that = this;
        that.loading = true;
        that.$confirm(msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true,
        })
          .then(() => {
            that.$http.urlpost('webdoc/doc/uploadCategoryFile', formData, function (res) {
              that.loading = false;
              if (res.Success > 0) {
                that.showGrid1(1);
              }
            });
            that.fileClear();
          })
          .catch(action => {
            that.fileClear();
          });

      },

      uploadTempToServer(index, rows) {
        // 上传PDF文件
        let that = this;
        if (index < 0 || rows == null) {
          that.search1.percentage = 100;
          that.fileClear();
          return;
        }
        this.search1.info = (index + 1) + '/' + rows.length;

        if (index >= rows.length) {
          that.search1.percentage = 100;
          for (let xx = 0; xx < rows.length; xx++) {
            if (rows[xx].enable_flag_text != '已上传') {
              that.search1.info = "";
              that.$message.warning(that.$t('getapi[11815]')+'</br>'+that.$t('getapi[11816]'));//批量上传已结束，传输过程有错误！/请重新上传！
              break;
            }
            rows[xx].file = null;
          }
          that.fileClear();
          return;
        }

        that.search1.percentage = parseInt(Math.round(100 * (index + 1) / parseFloat(rows.length)));

        let doc = rows[index];
        if (that.fnToNull(doc.docName2) == null) {
          doc.remark = '未匹配文件';
        } else if (doc.file == null) {
          doc.remark = '未选择文件';
        }
        else {
          doc.enable_flag_text = "上传中";
        }

        if (doc.enable_flag_text != '上传中') {
          // 下一条
          that.uploadTempToServer(index + 1, rows);
          return;
        }

        // 上传清单
        var formData = new FormData();
        formData.append("doc_id", doc.doc_id);
        formData.append("doc_name", doc.doc_name);
        formData.append("file", doc.file);
        formData.append("Token", that.mytoken());
        formData.append("LangType", that.$processdata.getLang());
        that.$http.urlpost('webdoc/doc/uploadTemp', formData, function (res) {
          // if (res.Success > 0) {
          //   that.showGrid1(1);
          // }
          if (res.Success == 1) {
            doc.enable_flag_text = "已上传";
            doc.file = null;
            doc.docName2 = null;
          } else if (res.Success == 100) {
            doc.enable_flag_text = "已上传";
            doc.file = null;
            doc.docName2 = null;
            // 清理
            that.uploadTempToServer(-1, rows);

            that.$message.success(that.$t('getapi[11817]'));//'清单已全部上传，自动进入审核状态！'
            // that.search1.enable_flag = "0";
            that.showGrid1(1);
            return;
          }
          else {
            doc.enable_flag_text = "重新上传";
            doc.remark = res.Msg;
          }
          // 下一笔
          that.uploadTempToServer(index + 1, rows);
        });
      },
      /************************/
      treeAdd() {
        let that = this
        that.treeOType = 1
        if (that.$refs.tree.getCurrentNode() != null) {
          if (that.curNode.node_id < 1) {
            that.$message.warning(that.$t('getapi[11818]'));//'新建节点必须保存后才能追加新节点！'
            return
          }
          let parm = {
            N1: 0,
            father_node_id: that.$refs.tree.getCurrentNode().node_id,
            flag: "1",
            node_id: that.nodeidflag--,
            node_name: "新建文件",
            root_id: null,
          }
          that.isactTitle = parm.node_name
          that.isact = parm
          if (!that.$refs.tree.getCurrentNode().children) {
            that.$set(that.$refs.tree.getCurrentNode(), "children", []);
            that.$refs.tree.getCurrentNode().children.push(parm)
          } else {
            that.$refs.tree.getCurrentNode().children.push(parm)
          }
          that.defaultEexpandedkeys = [
            ...that.defaultEexpandedkeys, that.curNode.node_id]
          this.$nextTick(function () {
            that.$refs.tree.setCurrentKey(parm.node_id)
            that.curNode = parm
          })
        } else {
          let parm = {
            N1: 0,
            father_node_id: null,
            flag: "1",
            node_id: that.nodeidflag--,
            node_name: "新建文件",
            root_id: null,
          }
          that.isactTitle = parm.node_name
          that.isact = parm
          that.dataTree.push(parm);
          this.$nextTick(function () {
            that.$refs.tree.setCurrentKey(parm.node_id)
            that.curNode = parm
          })
        }
        that.isUpdateGroup = true;
      },
      handleChangeTitle(e) {
        let that = this
        let value = e.target.value;
        that.isactTitle = value;
      },
      treeSave() {
        let that = this
        if (that.treeOType == 1) {
          let parm = {
            node_id: 0,
            node_name: that.isactTitle,
            father_node_id: that.isact.father_node_id,
            flag: 1,
            root_id: 0,
            Token: that.mytoken(),
            type:1
          }
          that.$http.urlpost('/webdoc/folder/add', parm, function (res) {
            if (res.Success == 1) {
              that.treeReflash(that.isact.father_node_id)
              that.isUpdateGroup = false
              that.treeOType = -1
            }
          });
        } else if (that.treeOType == 2) {
          let parm = {
            node_id: that.isact.node_id,
            node_name: that.isactTitle,
            father_node_id: that.isact.father_node_id,
            flag: 1,
            root_id: 0,
            Token: that.mytoken()
          }
          that.$http.urlpost('/webdoc/folder/update', parm, function (res) {
            if (res.Success == 1) {
              that.$set(that.curNode, 'node_id', res.DataContent.node_id)
              that.$set(that.curNode, 'node_name', res.DataContent.node_name)
              that.$set(that.curNode, 'father_node_id', res.DataContent.father_node_id)
              that.$set(that.curNode, 'flag', res.DataContent.flag)
              that.$set(that.curNode, 'root_id', res.DataContent.root_id)
              that.$set(that.curNode, 'N1', res.DataContent.N1)
              that.isUpdateGroup = false
              that.treeOType = -1
            }
          });
        }

      },
      treeDel() {
        let that = this
        if (that.curNode.node_id < 1) {
          that.$refs.tree.remove(that.curNode)
          return
        }
        this.$confirm(that.$t('getapi[11819]'), that.$t('getapi[194]'), {//确定删除该节点
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning'
        })
          .then(() => {
            let parm = {
              node_id: that.curNode.node_id,
              Token: that.mytoken()
            }
            that.$http.urlpost('/webdoc/folder/delete', parm, function (res) {
              if (res.Success == 1) {

                that.treeReflash(that.curNode.father_node_id)
                that.curNode = null
                that.isact = ''
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: that.$t('getapi[8574]')
            });
          });
      },
      treeReflash(parentKey) {
        let that = this
        let node_id = ''
        if (parentKey == '') {
          if (that.curNode == null) {
            that.getRootNode()
            that.isact = ''
            that.curNode = null
            that.treeOType = 1
            return
          } else {
            node_id = that.curNode.node_id;
            that.nodetype=that.curNode.type;
          }
        } else {
          node_id = parentKey
        }
        let parm = {
          father_node_id: node_id,
          type:'1,3',
        }
        that.$http.urlpost('/webdoc/folder/findList', parm, function (res) {
          if (parentKey == '') {
            that.$refs.tree.updateKeyChildren(that.$refs.tree.getCurrentKey(), res.DataContent)
          } else {
            that.$refs.tree.updateKeyChildren(parentKey, res.DataContent)
          }
          /*that.curNode.children = res.DataContent*/
        });
      },
      treeEdit() {
        let that = this
        that.isact = that.curNode
        that.isUpdateGroup = true
        if (that.isact.node_id < 1) {
          that.treeOType = 1
        } else {
          that.isactTitle = that.curNode.node_name;
          that.treeOType = 2
        }
      },
      
      treeSet() {
        let that = this
        let tips = ''
        let f = 'yes'
        if (that.curNode.node_id < 1) {
          that.$message.warning(that.$t('getapi[11820]'))//请先保存该数据
          return
        }
        if (that.curNode.node_id == that.curNode.root_id) {
          tips = that.$t('getapi[11821]') + that.curNode.node_name//'请确认，是否要取消区域节点？'
          f = 'no'
        } else {
          tips = that.$t('getapi[11822]') + that.curNode.node_name//'请确认，是否要设置为区域节点？'
          f = 'yes'
        }
        this.$confirm(tips, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning'
        })
          .then(() => {
            let parm = {
              node_id: that.curNode.node_id,
              flag: f,
              Token: that.mytoken()
            }
            that.$http.urlpost('/webdoc/folder/updaterootid', parm, function (res) {
              if (res.Success == 1) {
                if (f == 'no') {
                  that.curNode.root_id = null
                } else {
                  that.curNode.root_id = that.curNode.node_id
                }
                that.isUpdateGroup = false
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: that.$t('getapi[8574]')
            });
          });
      },
      /************************/
      dg1Click(text) {
        //console.log('dg1Click');
        let that = this;
        if (that.search3.dataSet == null) {
          return;
        }
        if (that.search3.dataSet.length == 0) {
          return;
        }
        if (!that.dg1.curRow) {
          return;
        }

        if (text == '显示') {
          that.dg1.visible = true;
          that.dg1.doc_id = that.dg1.curRow.doc_id;
          that.dg1.doc_name = that.dg1.curRow.doc_name;
          that.dg1.part_list = that.dg1.curRow.part_list;
          that.dg1.group_list = that.dg1.curRow.group_list;
          return;
        }
        else if (text == '修改') {
          that.dg1.part_list = that.fnToNull(that.dg1.part_list);
          if (!that.dg1.part_list) {
            that.$message.error( that.$t('getapi[11759]'));//'物料编码必须填写'
            return;
          }
        }
        else {
          that.dg1.visible = false;
          return;
        }
        let p1 = {
          doc_id: that.dg1.doc_id,
          part_list: that.dg1.part_list,
          group_list: that.dg1.group_list,
          Token: that.mytoken()
        };
        that.$confirm(that.$t('getapi[11823]')+'<br/>'+that.$t('getapi[3590]') + that.dg1.doc_name, that.$t('getapi[194]'), {//请确认，是否要更新？/文件名
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {

            // 更新
            that.$http.urlpost('/webdoc/doc/updateData', p1, function (res) {
              if (res.Success > 0) {
                that.dg1.visible = false;
                that.refreshGridRow(that.search3.dataSet, res.DataContent)
              }
            });
          })
          .catch(action => {
            if (action == "cancel") {
              return;
            }
            that.$message.error(that.$t('getapi[4085]'));//"审核失败！"
          });

      },
      search3RowClick(row, column, event) {
        this.dg1.curRow = row;
      },
      fileSearchChange() {
        // 清单检索,全局搜索文件
        let that = this;

        that.search1.info = null;
        let doc = document.getElementById('file3');
        if (!doc) {
          return;
        }
        let files = doc.files;
        if (files == null) {
          return null;
        }
        if (files.length == 0) {
          return null;
        }
        that.zip5.href = null;
        // 文件检索全局检索,参照批量检索条件
        let curSearch = that.search5;
        curSearch.searchGroup = false;
        curSearch.searchPart = false;
        curSearch.searchRoot = false;
        curSearch.FuzzyQuery = false;
        curSearch.cb10_nbt = false;
        curSearch.cb10_kht = false;
        curSearch.cb10_cgj = false;
        var formData = new FormData();
        formData.append("node_id", -1);
        formData.append("enable_flag", 2);
        if (curSearch.item_type) {
          formData.append("item_type", curSearch.item_type);
        }
        if (curSearch.blueprint_no1) {
          formData.append("blueprint_no1", curSearch.blueprint_no1);
        }
        if (curSearch.PublishDateTimeStart) {
          formData.append("PublishDateTimeStart", that.fnFmtDate(curSearch.PublishDateTimeStart) + " 00:00:00");
        }
        if (curSearch.PublishDateTimeEnd) {
          formData.append("PublishDateTimeEnd", that.fnFmtDate(curSearch.PublishDateTimeEnd) + " 23:59:59");
        }

        formData.append("Token", that.mytoken());
        formData.append("file", files[0]);
        that.search5.doc_name = null;
        // 检查
        that.loading = true;
        that.$http.urlpost('webdoc/doc/uploadSearchFile', formData, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          that.search5.dataSet = res.DataContent;
          that.search5.Page = res.Page;
          that.search5.Page.DbTbNames = res.DbTbNames;
          that.search5.doc_name = res.Operation.key;
          if (that.fnIntToNull(res.Operation.type) > 0) {
            that.$message.warning(that.$t('getapi[2475]')+":"+that.$t('getapi[1251]') + res.Operation.type + that.$t('getapi[11824]'));//注意：有/文件不存在
          }
        });
        that.fileClear();
        return;
      },
      downLoadZip() {
        // 打包下载
        let that = this;
        that.zip5.href = null;

        let rows;
        if (that.search5.multipleSelection == null || that.search5.multipleSelection.length == 0) {
          rows = that.search5.dataSet;
        }
        else {
          rows = that.search5.multipleSelection;
        }
        if (rows == null || rows.length == 0) {
          return;
        }
        let p1 = { ids: null, addblueprintNo: "0",FuzzyQuery:"0", Token: that.mytoken() };

        let ids = "";
        for (let i = 0; i < rows.length; i++) {
          ids = ids + rows[i].doc_id.toString() + ",";
        }

        p1.ids = ids
        if (that.search5.addblueprintNo) {
          p1.addblueprintNo = "1";
        }
        else {
          p1.addblueprintNo = "0";
        }

        if (that.search5.FuzzyQuery) {
          p1.FuzzyQuery = "1";
        }
        else {
          p1.FuzzyQuery = "0";
        }
        
        // 检查
        that.loading = true;

        that.$http.urlpost('webdoc/zip/downLoadZip', p1, function (res) {
          that.loading = false;
          if (res.Success <= 0) {
            return;
          }
          if (res.DataContent == null) {
            //未能获取
            that.$message.error(that.$t('getapi[11825]') + res.Msg);//"未能获取正确的压缩文件"
            return;
          }
          if (res.DataContent.doc_id == null) {
            //未能获取
            that.$message.error(that.$t('getapi[11825]') + res.DataContent.remark);//"未能获取正确的压缩文件"
            return;
          }

          that.zip5.href = res.DataContent.hash_value;
          that.zip5.doc_name = res.DataContent.doc_name;
          that.zip5.title = res.DataContent.doc_type + " " + res.DataContent.remark + that.$t('getapi[11826]');//等待下载
          // that.fnFmtPDFZip_New(that.zip5.href);
          var t = setTimeout(
            function () {
              let doc = document.getElementById("myzip1");
              doc.click();
            }
            , 500);
        });
      },
      classNameT5({ row, column, rowIndex, columnIndex }) {
        if (columnIndex != 1) {
          return '';
        }
        if (row.enable_flag_text == '不存在') {
          return 'myVersion';
        }
        return '';
      },
      //工艺取号
      handleSelectionChangeYL(val) {
        this.search6.multipleSelectionYL = val;
      },
      //批量检索
      handleSelectionChangePL(val) {
        this.search5.multipleSelection = val;
        console.log("测试批量检索")
        console.log( this.search5.multipleSelection);
      },
      mytoken() {
        console.log(this.userData);
        if (!this.userData) {
          return null;
        }
        return this.userData.token;
      },
      downLoadTemplate() {

      },

      onChangeFile2QC() {
        // 替换QE控制文件 上传文件
        let that = this;
        that.search1.info = null;
        let doc = document.getElementById('tb2QCfile');
        if (!doc) {
          return;
        }
        let fileRows = doc.files;
        if (fileRows == null) {
          return null;
        }
        if (fileRows.length == 0) {
          return null;
        }
        let gridRows = that.searchHJ.dataSet;
        if (gridRows == null || gridRows.length == 0) {
          that.$message.error(that.$t('getapi[11827]'));//缺少待审核文件，不能替换
          that.fileClear();
          return;
        }

        let warningFileN1 = 0;
        let arrFiles = [];
        for (let i = 0; i < fileRows.length; i++) {
          let name1 = fileRows[i].name.toLowerCase();
          let ok = false;
          for (let j = 0; j < gridRows.length; j++) {
            if (name1 == gridRows[j].doc_name.toLowerCase()) {
              arrFiles.push({ index: j, file: fileRows[i], dgRow: gridRows[j] });
              ok = true;
              break;
            }
          }
          if (!ok) {
            warningFileN1 = warningFileN1 + 1;
          }
        }

        that.fileClear();

        if (arrFiles.length == 0) {
          that.$message.warning(that.$t('getapi[194]'), that.$t('getapi[11828]'), 'info');//'未匹配到待替换文件'
          return;
        }

        let msg = that.$t('getapi[11829]')+'<br>'+that.$t('getapi[11830]')+':' + arrFiles.length + that.$t('getapi[11753]');//请确认，是否要替换质量文件?/共计/个文件
        if (warningFileN1) {
          msg = msg + "<br/>"+that.$t('getapi[241]')+":" + warningFileN1 + that.$t('getapi[11831]');//警告/个文件未匹配
        }

        that.$confirm(msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            var t = setTimeout(
              function () {
                that.uploadQCFileToServer(0, arrFiles);
              }
              , 100);
            return;
          })
          .catch(action => {
            that.fileClear();
          });
      },
      uploadQCFileToServer(n, arrFiles) {
        // Q替换 文件上传服务器
        let that = this;
        if (n < 0 || arrFiles == null) {
          that.searchHJ.info = "";
          return;
        }
        if (n >= arrFiles.length) {
          that.searchHJ.info = "";

          that.showGrid1(1);
          return;
        }
        var sInfoS1 = (n + 1) + " / " + arrFiles.length;

        that.searchHJ.info = sInfoS1 + " 上传中...";

        let doc = arrFiles[n].dgRow;
        console.log('------质量替换-------', doc);

        var url;
        var formData = new FormData();
        formData.append("doc_id", doc.doc_id);
        formData.append("doc_name", doc.doc_name);
        formData.append("file", arrFiles[n].file);
        formData.append("LangType", that.$processdata.getLang());
        that.$http.urlpost('webdoc/doc/uploadQC', formData, function (res) {
          if (res.Success == 1) {
            doc.enable_flag_text = "已替换";
            doc.file = null;
            doc.docName2 = null;
            doc.qc_flag = "1";
            that.searchHJ.info = sInfoS1 + " " + doc.docName + " 已替换";

          }
          else {
            doc.enable_flag_text = "失败";
            doc.remark = "需要重新上传";
            that.searchHJ.info = sInfoS1 + " 需要重新上传...";
          }

          // 下一笔
          that.uploadQCFileToServer(n + 1, arrFiles);
        });
      },
      searchRootChange() {
        let that = this;
        if (that.search5.searchRoot) {
          that.search5.cb10_nbt = false;
          that.search5.cb10_kht = false;
          that.search5.cb10_cgj = false;
          that.search5.doc_id=''
        }
      },
      /************/
      onChangeFile4DXF() {
        // DXF直接上传
        let that = this;
        that.search1.info = null;
        let doc = document.getElementById('tbDXFfile');
        if (!doc) {
          return;
        }
        let fileRows = doc.files;
        if (fileRows == null) {
          return null;
        }
        if (fileRows.length == 0) {
          return null;
        }

        // 上传目录文件列表
        let node1 = that.curNode;
        console.log('------DXF文件-------', node1);
        if (node1 == null) {
          that.$message.error(that.$t('getapi[11832]'));//'选择的节点不正确，不能上传DXF文件。'
          $('#tbDXFfile').val(null);
          return;
        }
        if (node1.node_id == null) {
          that.$message.error(that.$t('getapi[11833]'));//'选择的节点缺少父节点信息，不能上传DXF文件。'
          $('#tbDXFfile').val(null);
          return;
        }
        if (node1.root_id == null) {
          that.$message.error(that.$t('getapi[11834]'));//'选择的节点缺少根目录信息，不能上传DXF文件。'
          $('#tbDXFfile').val(null);
          return;
        }

        let rows = [];
        for (let i = 0; i < fileRows.length; i++) {
          rows.push({
            doc_id: i, node_id: node1.node_id, enable_flag_text: '等待上传', doc_version: '-', part_list: '-', group_list: 'DXF',
            doc_name: fileRows[i].name, file: fileRows[i], docName2: fileRows[i].name
          });
        }
        that.search1.dataSet = rows;
        $('#tbDXFfile').val(null);
        that.showUploadDXF(rows);
        return;
      },
      showUploadDXF(rows) {
        let that = this;
        if (rows == null) {
          return;
        }
        let msg = that.$t('getapi[11835]')+'<br>'+that.$t('getapi[11830]')+':' + rows.length + that.$t('getapi[11753]');//请确认，是否要上传DXF文件?/共计/个文件
        that.$confirm(msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            var t = setTimeout(
              function () {
                that.uploadDXF(0, rows);
              }
              , 100);
            return;
          })
          .catch(action => {
            that.fileClear();
          });
      },
      uploadDXF(index, rows) {
        let that = this;
        if (index < 0 || rows == null) {
          return;
        }
        if (index >= rows.length) {
          // SetProgressbarValue(true, 2);
          // that.showGrid1(1);
          return;
        }

        var row = rows[index];
        var bContinue = false;
        if (row.docName2 == null || row.docName2 == '') {
          row.remark = '未匹配文件';
          bContinue = true;
        } else if (row.file == null) {
          row.remark = '未选择文件';
          bContinue = true;
        }
        else {
          row.status = '上传中...';
        }
        // $('#gd6').datagrid('refreshRow', index);
        // SetProgressbarValue(false, 2);

        // 不需要上传,直接调用下一个
        if (bContinue) {
          that.uploadDXF(index + 1, rows);
          return;
        }
        console.log('-----uploadDXF--------', row);

        var formData = new FormData();
        formData.append("node_id", row.node_id);
        formData.append("doc_name", row.doc_name);
        formData.append("file", row.file);
        that.$http.urlpost('webdoc/doc/uploadDXF', formData, function (res) {
          if (res.Success == 1) {
            row.enable_flag_text = "已上传";
            if(index==rows.length){
              that.$message.success(that.$t('getapi[11836]'));//'取号成功！'
            }
          }
          else {
            row.enable_flag_text = "警告";
          }

          // 下一笔
          var t = setTimeout(
            function () {
              that.uploadDXF(index + 1, rows);
            }, 150);
        });
      },
      /************/
      onChangeFile4DWG() {
        // DXF直接上传
        let that = this;
        that.search1.info = null;
        let doc = document.getElementById('tbDWGfile');
        if (!doc) {
          return;
        }
        let fileRows = doc.files;
        if (fileRows == null) {
          return null;
        }
        if (fileRows.length == 0) {
          return null;
        }

        // 上传目录文件列表
        let node1 = that.curNode;
        console.log('------DWG文件-------', node1);
        if (node1 == null) {
          that.$message.error(that.$t('getapi[11837]'));//'选择的节点不正确，不能上传DWG文件。'
          $('#tbDWGfile').val(null);
          return;
        }
        if (node1.node_id == null) {
          that.$message.error(that.$t('getapi[11838]'));//'选择的节点缺少父节点信息，不能上传DWG文件。'
          $('#tbDWGfile').val(null);
          return;
        }
        if (node1.root_id == null) {
          that.$message.error(that.$t('getapi[11839]'));//'选择的节点缺少根目录信息，不能上传DWG文件。'
          $('#tbDWGfile').val(null);
          return;
        }

        let rows = [];
        for (let i = 0; i < fileRows.length; i++) {
          rows.push({
            doc_id: i, node_id: node1.node_id, enable_flag_text: '等待上传', doc_version: '-', part_list: '-', group_list: 'DXF',
            doc_name: fileRows[i].name, file: fileRows[i], docName2: fileRows[i].name
          });
        }
        that.search1.dataSet = rows;
        $('#tbDWGfile').val(null);
        that.showUploadDWG(rows);
        return;
      },
      showUploadDWG(rows) {
        let that = this;
        if (rows == null) {
          return;
        }
        let msg = that.$t('getapi[11840]')+'<br>'+that.$t('getapi[11830]')+':' + rows.length + that.$t('getapi[11753]');//请确认，是否要上传DWG文件/共计/个文件
        that.$confirm(msg, that.$t('getapi[194]'), {
          confirmButtonText: that.$t('getapi[1146]'),
          cancelButtonText: that.$t('getapi[2054]'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            var t = setTimeout(
              function () {
                that.uploadDWG(0, rows);
              }
              , 100);
            return;
          })
          .catch(action => {
            that.fileClear();
          });
      },
      uploadDWG(index, rows) {
        let that = this;
        if (index < 0 || rows == null) {
          return;
        }
        if (index >= rows.length) {
          return;
        }

        var row = rows[index];
        var bContinue = false;
        if (row.docName2 == null || row.docName2 == '') {
          row.remark = '未匹配文件';
          bContinue = true;
        } else if (row.file == null) {
          row.remark = '未选择文件';
          bContinue = true;
        }
        else {
          row.status = '上传中...';
        }
        // 不需要上传,直接调用下一个
        if (bContinue) {
          that.uploadDWG(index + 1, rows);
          return;
        }
        console.log('-----uploadDWG--------', row);

        var formData = new FormData();
        formData.append("node_id", row.node_id);
        formData.append("doc_name", row.doc_name);
        formData.append("file", row.file);
        that.$http.urlpost('webdoc/doc/uploadDWG', formData, function (res) {
          if (res.Success == 1) {
            row.enable_flag_text = "已上传";
          }
          else {
            row.enable_flag_text = "警告";
          }

          // 下一笔
          var t = setTimeout(
            function () {
              that.uploadDWG(index + 1, rows);
            }, 150);
        });
      },
      showOpenNumber(){
          let that=this;
          that.loading = false;
          that.isVisibleNumber=true;
          that.formInline.id_sort=0;
          that.formInline.id_text=that.WIPre;
          that.formInline.id_dept="";
          that.formInline.id_wi=that.WIType;
          that.formInline.id_item="";
          that.formInline.id_type="";
          that.formInline.id_start=0;
          that.formInline.id_no=1;
          that.formInline.id_end="";
          that.formInline.id_group="";
          that.formInline.action_time="";
          that.formInline.action_user="";
          that.formInline.remark="";
          
      },
      OpenNumberSava() {
        let that = this;
        that.loading = true;
        if(that.$limits.fnIsEmpty(that.formInline.id_text)){
            that.$message.warning(that.$t('getapi[11771]'));//'工艺前缀必须填写'
            that.loading = false;
            return;
        }
        // if(that.$limits.fnIsEmpty(that.formInline.id_wi)){
        //     that.$message.warning('类型必须填写');
        //     that.loading = false;
        //     return;
        // }
        if(that.$limits.fnIsEmpty(that.formInline.id_dept)){
            that.$message.warning(that.$t('getapi[11772]'));//'工艺部门必须填写'
            that.loading = false;
            return;
        }
        if(that.$limits.fnIsEmpty(that.formInline.id_type)){
            that.$message.warning(that.$t('getapi[11841]'));//'工序类型必须填写'
            that.loading = false;
            return;
        }
        if(that.$limits.fnIsEmpty(that.formInline.id_item)){
            that.$message.warning(that.$t('getapi[11842]'));//'项目代码必须填写'
            that.loading = false;
            return;
        }
        if(that.$limits.fnIsEmpty(that.formInline.id_no)){
            that.$message.warning(that.$t('getapi[11843]'));//'取号数量必须填写'
            that.loading = false;
            return;
        }
        else{
          if(that.formInline.id_no<=0){
              that.$message.warning(that.$t('getapi[11843]'));//'取号数量必须填写'
              that.loading = false;
              return;
          }
        }
        that.$http.urlpost('webdoc/doc/SaveNum', that.formInline, function(res) {
          if (res.Success == 1) {
              that.$message.success(that.$t('getapi[11836]'));//'取号成功！'
              that.isVisibleNumber=false;
              that.showGrid1(1);
          }
          that.loading = false;
        });
      },
        saomadown(){
            let that = this
            that.keydowntime = new Date().getTime()
            /*that.showGrid1(1)
            that.search4.part_list = ''*/
        },
        saomaup(){
            let that = this
            that.keyuptime = new Date().getTime()
            if(that.keyuptime -  that.keydowntime<30){
                that.showGrid1(2)
                console.log(11111)
            } else {
                console.log(22222)
            }
        }
      /**********mo*********/
    }
  };
</script>

<style scoped lang="less">
  .c-search-table {
    width: 100%;
    height: calc(~"100% - 10px");
    /*这里我用了计算属性*/
  }

  .beauty-Scroll {
    .el-scrollbar {
      height: 100%;
      /*此处一定要设置高度，不然内层的计算属性不生效*/
    }

    .el-scrollbar__wrap {
      width: calc(~"100% + 17px");
      /*将垂直滚动条挤到可视区域之外*/
      height: calc(~"100% + 17px");
      /*将水平滚动条挤到可视区域之外*/
    }
  }

  input {
    width: 100%;
    height: 35px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    padding-left: 2px;
    padding-right: 2px;
    min-width: 120px;
  }

  table {
    border-collapse: separate;
    border-spacing: 0px 5px;

    td {
      padding-left: 3px;
    }
  }

  .alignment-left {
    text-align: left;
  }

  .alignment-right {
    text-align: right;
  }

  .el-pagination {
    white-space: inherit;
  }

  .el-divider--horizontal {
    margin: 10px 0;
  }

  /deep/.el-table tbody tr:hover>td {
    background-color: transparent !important;
  }

  /deep/ .myRootNode {
    color: green;
  }

  /deep/ .text-red {

    color: red;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    font-family: '微软雅黑';
  }

  /deep/ .myCell {
    vertical-align: top;
    width: 120px;
    padding-left: 5px;
  }

  /deep/ .myCellNew {
    vertical-align: top;
    width: 65px;
    padding-left: 5px;
  }

  /deep/ .myCellText {
    width: 80px;
    text-align: right;
  }

  /deep/ .myCellText_View {
    width: 70px;
    text-align: right;
    padding-left: 0px;
  }
  /deep/ .myCellText_btn {
    width: 60px;
    text-align: left;
    padding-left: 0px;
  }
  /deep/ .myCellText_btn_hjt {
    width: 80px;
    text-align: right;
  }
  /deep/ .myCellText_chex {
    width: 100px;
    text-align: left;
    padding-left: 0px;
  }
  /deep/ .myCellText_batch {
    width: 60px;
    text-align: right;
    padding-left: 0px;
  }
  /deep/ .myCell_btn_right {
    vertical-align: top;
    width: 120px;
    text-align: right;
    // padding-left: 5px;
  }
  /deep/ .myVersion {
    color: blue;
    /* background-color: #fff; */
  }

  /deep/ .myLi li {
    display: inline-block;
  }

  /deep/ .rowStyler6 {
    /* 控件BUG,前景色改成红色 */
    /* background-color: #ff0000;
    color: #fff; */
    color: #ff0000;
    font-weight: bold;
  }
  /deep/ .yellow {
    background-color:yellow;
  }
  /deep/ .green {
    background-color: #8ced99;
  }
  
</style>